webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd834028_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__ = __webpack_require__(842);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd834028_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751354da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__ = __webpack_require__(930);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserQueries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_751354da_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UserQueries_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_targets_targets__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Accounts_Accounts__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Visits_Visits__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_equipment_Equipment__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_sra_Sra__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_promotions_Promotions__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_stocks_Stocks__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_pages_Page404__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_pages_Page500__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_pages_Login__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_pages_Forgot__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_pages_ResetPassword__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_tables_missingRouter_js__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_users_UsersGrid__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_users_UsersEdit__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_users_Profile__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_roles_grid__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_roles_edit__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_statistics_Statistics__ = __webpack_require__(1027);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var usersRoutes = {
  path: '/users',
  redirect: '/users/index',
  name: 'users',
  meta: {
    auth: {
      redirect: {
        name: 'users.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'index',
    name: 'users.index',
    component: __WEBPACK_IMPORTED_MODULE_17__views_users_UsersGrid__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'users.create',
    component: __WEBPACK_IMPORTED_MODULE_18__views_users_UsersEdit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'users.edit',
    component: __WEBPACK_IMPORTED_MODULE_18__views_users_UsersEdit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
};

var rolesRoutes = {
  path: '/roles',
  redirect: '/roles/index',
  name: 'roles',
  meta: {
    auth: {
      redirect: {
        name: 'roles.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'index',
    name: 'roles.index',
    component: __WEBPACK_IMPORTED_MODULE_20__views_roles_grid__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'roles.create',
    component: __WEBPACK_IMPORTED_MODULE_21__views_roles_edit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'roles.edit',
    component: __WEBPACK_IMPORTED_MODULE_21__views_roles_edit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'targets',
      name: 'targets',
      component: __WEBPACK_IMPORTED_MODULE_4__views_targets_targets__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'accounts',
      name: 'accounts',
      component: __WEBPACK_IMPORTED_MODULE_5__views_Accounts_Accounts__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'visits',
      name: 'visits',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Visits_Visits__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'stocks',
      name: 'stocks',
      component: __WEBPACK_IMPORTED_MODULE_10__views_stocks_Stocks__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'equipment',
      name: 'equipment',
      component: __WEBPACK_IMPORTED_MODULE_7__views_equipment_Equipment__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'promotions',
      name: 'promotions',
      component: __WEBPACK_IMPORTED_MODULE_9__views_promotions_Promotions__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'sra',
      name: 'sra',
      component: __WEBPACK_IMPORTED_MODULE_8__views_sra_Sra__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: 'profile',
      name: 'profile',
      component: __WEBPACK_IMPORTED_MODULE_19__views_users_Profile__["a" /* default */],
      meta: {
        auth: true
      }
    }, {
      path: '/statistics',
      redirect: '/statistics/index',
      name: 'statistics',
      meta: {
        auth: true,
        label: 'DIM'
      },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: ':id',
        name: 'statistics.index',
        component: __WEBPACK_IMPORTED_MODULE_22__views_statistics_Statistics__["a" /* default */],
        meta: {
          auth: true,
          label: 'Lista'
        }
      }]
    }, __WEBPACK_IMPORTED_MODULE_16__views_tables_missingRouter_js__["a" /* default */], usersRoutes, rolesRoutes]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_13__views_pages_Login__["a" /* default */]
  }, {
    path: '/forgot-password',
    name: 'forgot-password',
    component: __WEBPACK_IMPORTED_MODULE_14__views_pages_Forgot__["a" /* default */]
  }, {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: __WEBPACK_IMPORTED_MODULE_15__views_pages_ResetPassword__["a" /* default */]
  }, {
    path: '/404',
    name: '404 Not Found',
    component: __WEBPACK_IMPORTED_MODULE_11__views_pages_Page404__["a" /* default */]
  }, {
    path: '/500',
    name: '500 Internal error',
    component: __WEBPACK_IMPORTED_MODULE_12__views_pages_Page500__["a" /* default */]
  }]
}));

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f30ff1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(928);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f30ff1a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e80625a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(909);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e80625a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdAgregFilter_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a03f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProdAgregFilter_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProdAgregFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a03f832_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProdAgregFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientFilter_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c52e35b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientFilter_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c52e35b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ClientFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutineFilter_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76032a58_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RoutineFilter_vue__ = __webpack_require__(927);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoutineFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76032a58_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RoutineFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridLocal_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047e8b8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GridLocal_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridLocal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047e8b8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GridLocal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__progress_kendo_ui_js_cultures_kendo_culture_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__progress_kendo_ui_js_messages_kendo_messages_pt_PT_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_StatisticsGrid_vue__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_GenericGrid_vue__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_scrollto__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_currency_filter__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);





























console.log(Window.appConfig);
__WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.culture('pt-PT');
Window.prototype.$ = __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.jQuery;

function percent(a, b) {
  if (b === 0) {
    return 0;
  }
  return Math.round(a / b * 10000) / 100;
}
Window.prototype.percent = percent;

function growth(a, b) {
  if (b === 0) {
    return 0;
  }
  return Math.round((a - b) / b * 10000) / 100;
}
Window.prototype.growth = growth;

function growthFormat(p) {
  var icon = '<i class="fa fa-minus"></i>';
  if (p > 0) {
    icon = '<i class="fa fa-arrow-up text-success"></i>';
  } else if (p < 0) {
    icon = '<i class="fa fa-arrow-down text-danger"></i>';
  } else {
    icon = '<i class="fa fa-equals text-secondary"></i>';
  }
  return __WEBPACK_IMPORTED_MODULE_14__progress_kendo_ui_js_kendo_all_js___default.a.toString(p, 'n1') + '% ' + icon;
}
Window.prototype.growthFormat = growthFormat;

__WEBPACK_IMPORTED_MODULE_19_moment___default.a.locale('pt');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_19_moment___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-top-center',
  defaultType: 'info',
  defaultTimeout: 1000
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_currency_filter__["a" /* default */], {
  symbol: '€',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: true
});
var apiRoot = "http://dim.test/";
if (typeof Window.appConfig !== 'undefined' && Window.appConfig.baseUrl !== 'undefined') {
  apiRoot = Window.appConfig.baseUrl;
}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.APIURL = apiRoot;
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL = apiRoot;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(1080), {
  http: function http(data) {
    this.Vue.axios.post(data.url, data.body, {
      progress: data.progress
    }).then(data.success, data.error);
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */];

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '$lodash', {
  value: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default.a);

var isUniqueUsername = function isUniqueUsername(value, args) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post('users/username', { username: value, user_id: args[0] }).then(function (response) {
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    };
  });
};
var isUniqueEmail = function isUniqueEmail(value, args) {
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post('users/email', { email: value, user_id: args[0] }).then(function (response) {
    return {
      valid: response.data.valid,
      data: {
        message: response.data.message
      }
    };
  });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* default */], {
  locale: 'pt_PT',
  inject: true,
  fieldsBagName: 'veeFields'
});
__WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default.a.attributes = {
  email: 'Email',
  name: 'Nome',
  username: 'Nome de utilizador',
  password: 'Palavra-passe',
  password_confirm: 'Confirme a palavra-passe'
};
__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].localize('pt_PT', __WEBPACK_IMPORTED_MODULE_13_vee_validate_dist_locale_pt_PT_js___default.a);

__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].extend('username', {
  validate: isUniqueUsername,
  getMessage: function getMessage(field, params, data) {
    console.log(data);
    return data.message;
  }
});
__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].extend('uniqueemail', {
  validate: isUniqueEmail,
  getMessage: function getMessage(field, params, data) {
    console.log(data);
    return data.message;
  }
});


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__websanova_vue_auth___default.a, {
  auth: __webpack_require__(1082),
  http: __webpack_require__(1083),
  router: __webpack_require__(1084),
  authRedirect: {
    path: '/login'
  },
  fetchData: {
    url: 'users/me'
  },
  refreshData: {
    url: 'auth/refresh'
  },

  check: function check(role) {
    if (this.watch.authenticated === true) {
      if (role) {
        if (__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare('superuser', this.watch.data['permissions'])) {
          return true;
        }
        return __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare(role, this.watch.data['roles']) || __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth_src_lib_utils_js___default.a.compare(role, this.watch.data['permissions']);
      }
      return true;
    }
    return false;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.perms = function (perm) {
  return this.options.check.call(this, perm, 'permissions');
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('statistics-grid', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_17__components_StatisticsGrid_vue__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('generic-grid', __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_18__components_GenericGrid_vue__["a" /* default */]));

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921744a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(620)
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_921744a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.ready())?_c('div',[_c('router-view')],1):_vm._e(),_vm._v(" "),(!_vm.$auth.ready())?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */,
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cec539_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(843);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44cec539_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(629);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'nav-icon icon-speedometer'
  }, {
    name: 'Objetivos',
    url: '/targets',
    icon: 'fa fa-table'
  }, {
    name: 'DIM',
    url: '/statistics/index',
    icon: 'fa fa-table'
  }, {
    name: 'Contas Correntes',
    url: '/accounts',
    icon: 'fa fa-list',
    auth: ['currentaccounts.access']
  }, {
    name: 'Visitas',
    url: '/visits',
    icon: 'fa fa-list',
    auth: ['visits.access']
  }, {
    name: 'Stocks',
    url: '/stocks',
    icon: 'fa fa-list',
    auth: ['stocks.access']
  }, {
    name: 'Equipamentos',
    url: '/equipment',
    icon: 'fa fa-list',
    auth: ['cabinets.access']
  }, {
    name: 'Promoções',
    url: '/promotions',
    icon: 'fa fa-list',
    auth: ['promotions.access']
  }, {
    name: 'SRAs',
    url: '/sra',
    icon: 'fa fa-list',
    auth: ['sra.access']
  }, {
    divider: true
  }, {
    name: 'Tabelas',
    url: '/tables',
    icon: 'icon-puzzle',
    auth: ['import.tables'],
    children: [{
      name: 'SKUs em falta',
      url: '/tables/missing-skus',
      icon: 'icon-puzzle'
    }, {
      name: 'Codles em falta',
      url: '/tables/missing-codles',
      icon: 'icon-puzzle'
    }, {
      name: 'Res. Importação',
      url: '/tables/import-batches',
      icon: 'icon-puzzle'
    }, {
      name: 'Obj. Contas',
      url: '/tables/settings',
      icon: 'icon-puzzle'
    }, {
      name: 'Produtos',
      url: '/tables/products',
      icon: 'fa fa-table'
    }, {
      name: 'Prod.Agregs',
      url: '/tables/prodaggregs',
      icon: 'fa fa-table'
    }, {
      name: 'Gamas',
      url: '/tables/mpg',
      icon: 'fa fa-table'
    }, {
      name: 'Marcas',
      url: '/tables/brands',
      icon: 'fa fa-table'
    }, {
      name: 'Cores',
      url: '/tables/cores',
      icon: 'fa fa-table'
    }, {
      name: 'Operadores',
      url: '/tables/clients',
      icon: 'fa fa-table'
    }, {
      name: 'Grupos Operadores',
      url: '/tables/operatorgroups',
      icon: 'fa fa-table'
    }, {
      name: 'Visibilidades',
      url: '/tables/visibilities',
      icon: 'fa fa-table'
    }, {
      name: 'Tipos Actividades',
      url: '/tables/activities',
      icon: 'fa fa-table'
    }, {
      name: 'Vendas',
      url: '/tables/sales',
      icon: 'fa fa-table'
    }]
  }, {
    divider: true
  }, {
    name: 'Utilizadores',
    url: '/users',
    icon: 'fa fa-users',
    auth: ['users.list']
  }, {
    name: 'Grupos',
    url: '/roles',
    icon: 'fa fa-users',
    auth: ['roles.list']
  }, {
    divider: true
  }]
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid_vue__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* unused harmony reexport Footer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */
/* unused harmony reexport Grid */











/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08aeefc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(632);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08aeefc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5dba9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d5dba9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059ad2fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(638);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059ad2fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b587677e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(641);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b587677e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")]),_vm._v(" © 2017 creativeLabs.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73229f9a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(644);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73229f9a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  data: function data() {
    return {
      user: this.$auth.user()
    };
  },

  methods: {
    logout: function logout() {
      this.$auth.logout();
      this.$router.push({
        name: 'login'
      });
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_vm._v("☰")]),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto mr-3",attrs:{"is-nav-bar":""}},[_c('b-nav-item-dropdown',{attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"//www.gravatar.com/avatar/?d=mysteryman&s=200","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('span',{staticClass:"d-md-down-none"},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'profile' }}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Perfil")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa108fb4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(686);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa108fb4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__ = __webpack_require__(683);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_5__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_6__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_7__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29bc3e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(650);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f29bc3e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea69fec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea69fec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019d85d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(656);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019d85d3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae6e3f84_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae6e3f84_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499704_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed499704_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acaf667_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(666);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acaf667_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 665 */,
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n      "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7e2bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(682);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b7e2bb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")])]:[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc8d00_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(685);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc8d00_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return (!item.auth || _vm.$auth.check(item.auth))?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}),0)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]:_vm._e()})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdcd95a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(689);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bdcd95a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSource"]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend: function beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    var that = this;
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options']);
    }
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      var grid = this.$refs.mygrid.kendoWidget();
      localStorage[this.name + 'options'] = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.stringify(grid.getOptions());
    } catch (error) {}
  }
});

/***/ }),
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-fields":_vm.schemaModelFields,"schema-total":_vm.schemaTotal,"schema-data":'data',"page-size":10,"server-paging":true,"server-filtering":true,"server-sorting":true,"page":_vm.options.dataSource.page,"filter":_vm.options.dataSource.filter,"sort":_vm.options.dataSource.sort}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"height":_vm.height,"data-source-ref":'datasource1',"pageable":_vm.pageable,"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_vm._v(" "),_c('AppAside')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26f980_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(852);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26f980_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_ObjectivesTable__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_EffectivenessTable__ = __webpack_require__(849);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    ObjectivesTable: __WEBPACK_IMPORTED_MODULE_0__dashboard_ObjectivesTable__["a" /* default */],
    EffectivenessTable: __WEBPACK_IMPORTED_MODULE_1__dashboard_EffectivenessTable__["a" /* default */]
  },
  data: function data() {
    return {
      lastUpdate: [],
      mpgObjectives: {
        liters: [],
        gsv: [],
        operators6: [],
        operators3: [],
        operators: []
      },
      objectivesPeriods: [{
        value: 1,
        text: 'mês'
      }, {
        value: 2,
        text: 'acumulado até'
      }],
      selectedMonth: null,
      zone: null,
      selectedPeriod: 1,
      selectedMonthLitersLE: null,
      effectiveness: [],
      litersLE: [],
      accounts: {
        open_docs: 0,
        expired_docs: 0,
        avg_expired_docs: 0,
        days_behind: 0,
        open_value: 0,
        expired_value: 0
      },
      monthOptions: [],
      objectivesZones: [],
      effectivenessCurrentPage: 1,
      effectivenessFields: [{ key: 'team', label: 'Vendedor', sortable: true }, { key: 'visits', label: 'Visitas', sortable: true }, { key: 'sales', label: 'Encomendas', sortable: true }, { key: 'effectiveness', label: 'Efetividade', sortable: true }],
      objectiveFields: [{ key: 'name', label: 'Gama', sortable: true }, { key: 'objective_value', label: 'Objectivo', sortable: true }, { key: 'current', label: 'Realizado', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      objectiveFieldsWithBalance: [{ key: 'name', label: 'Gama', sortable: true }, { key: 'objective_value', label: 'Objectivo', sortable: true }, { key: 'current', label: 'Realizado', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }, { key: 'balance', label: 'Saldo', sortable: true }],
      objectiveFieldsWithQT: [{ key: 'name', label: 'Gama', sortable: true }, { key: 'objective_value', label: 'Objectivo', sortable: true }, { key: 'current', label: 'Realizado', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }, { key: 'remaining', label: 'QT', sortable: true }],
      objectiveFieldsLE: [{ key: 'name', label: 'Gama', sortable: true }, { key: 'objective_value', label: 'Homólogo', sortable: true }, { key: 'current', label: 'Realizado', sortable: true }, { key: 'progress', label: 'Progresso', sortable: true }],
      tableFields: {
        tablename: {
          label: 'Tabela'
        },
        last_update: {
          label: 'Última atualização'
        }
      }
    };
  },
  watch: {
    zone: {
      handler: function handler(zone) {
        var p = this.selectedPeriod;
        var m = this.selectedMonth;
        console.log('period', p);
        this.loadObjectives('liters', p, m, zone);
        this.loadObjectives('gsv', p, m, zone);
        this.loadObjectives('operators', p, m, zone);
        this.loadObjectives('operators3', p, m, zone);
        this.loadObjectives('operators6', p, m, zone);
      }
    },
    selectedMonth: {
      handler: function handler(newValue) {
        var p = this.selectedPeriod;
        var zone = this.zone;
        console.log('period', p);
        this.loadObjectives('liters', p, newValue, zone);
        this.loadObjectives('gsv', p, newValue, zone);
        this.loadObjectives('operators', p, newValue, zone);
        this.loadObjectives('operators3', p, newValue, zone);
        this.loadObjectives('operators6', p, newValue, zone);
      }
    },
    selectedPeriod: {
      handler: function handler(newValue) {
        var p = this.selectedMonth;
        var zone = this.zone;
        this.loadObjectives('liters', newValue, p, zone);
        this.loadObjectives('gsv', newValue, p, zone);
        this.loadObjectives('operators', newValue, p, zone);
        this.loadObjectives('operators3', newValue, p, zone);
        this.loadObjectives('operators6', newValue, p, zone);
      }
    },
    selectedMonthLitersLE: {
      handler: function handler(newValue) {
        this.loadLitersLE(newValue);
      }
    }
  },
  methods: {
    loadObjectives: function loadObjectives(objectiveType, period, dts, zone) {
      var _this = this;

      var data = {
        analysisType: period,
        columns: 'gsv',
        rows: 'products',
        subrows: 'mpg_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: {
            day: dts.start,
            month: dts.month
          },
          end: {
            day: dts.end,
            month: dts.month
          }
        },
        zone: zone
      };
      if (period === 2) {
        data.dates.start.day = 1;
        data.dates.start.month = 1;
      }
      console.log(period);
      this.axios.post('dashboard/mpg_objectives/' + objectiveType + '/' + dts.year_month, data).then(function (response) {
        _this.mpgObjectives[objectiveType] = response.data.data;
      });
    },
    loadLitersLE: function loadLitersLE(dts) {
      var _this2 = this;

      var data = {
        columns: 'gsv',
        rows: 'products',
        subrows: 'mpg_id',
        groupby: 'none',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: dts.end,
            month: dts.month
          }
        }
      };

      this.axios.post('dashboard/objectives/litersLE/' + dts.year_month, data).then(function (response) {
        _this2.litersLE = response.data.data;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    console.log(this.$auth.check('dashboard.objectives'));
    this.axios.get('lastupdate').then(function (response) {
      _this3.lastUpdate = response.data.data;
    });
    this.axios.get('dashboard/objectives').then(function (response) {
      _this3.monthOptions = response.data.data.months;
      _this3.objectivesZones = response.data.data.zones;
      _this3.zone = _this3.objectivesZones[0].value;
      _this3.selectedMonth = _this3.monthOptions[1].value;
      _this3.selectedMonthLitersLE = _this3.monthOptions[1].value;
    });
    this.axios.get('dashboard/objectives/accounts').then(function (response) {
      _this3.accounts = response.data.data;
    });

    this.axios.get('dashboard/objectives/effectiveness').then(function (response) {
      _this3.effectiveness = response.data.data;
    });
  }
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectivesTable_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bdc245_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectivesTable_vue__ = __webpack_require__(848);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ObjectivesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35bdc245_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ObjectivesTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'fields', 'table-caption', 'symbol', 'per-page', 'show-remaining'],
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a
  },
  data: function data() {
    return {
      currentPage: 1
    };
  },

  methods: {},
  created: function created() {
    console.log('Remaining:', this.showRemaining);
  }
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"table-caption"},[_vm._v(_vm._s(_vm.tableCaption))]),_vm._v(" "),_c('VuePerfectScrollbar',{staticClass:"objetives-table-holder"},[_c('b-table',{attrs:{"responsive":"","stacked":"sm","fields":_vm.fields,"items":_vm.items,"per-page":_vm.perPage,"current-page":_vm.currentPage},scopedSlots:_vm._u([{key:"name",fn:function(data){return [(data.item.variant == 'success')?_c('i',{class:'fa fa-thumbs-up text-'+data.item.variant}):_vm._e(),_vm._v(" "),(data.item.variant != 'success')?_c('i',{class:'fa fa-thumbs-down text-'+data.item.variant}):_vm._e(),_vm._v(" "+_vm._s(data.item.name)+"\n    ")]}},{key:"cell(objective_value)",fn:function(data){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(Math.round(data.item.objective_value),{fractionCount:0, symbol:_vm.symbol}))+"\n    ")]}},{key:"cell(current)",fn:function(data){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(Math.round(data.item.current),{fractionCount:0, symbol:_vm.symbol}))+"\n    ")]}},{key:"cell(progress)",fn:function(data){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(data.item.progress,{fractionCount:1, symbol:'%'}))+"\n    ")]}},{key:"cell(remaining)",fn:function(data){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(data.item.remaining,{fractionCount:0, symbol:''}))+"\n    ")]}},{key:"cell(balance)",fn:function(data){return [_vm._v("\n      "+_vm._s(_vm._f("currency")(Math.round(data.item.current - data.item.objective_value),{fractionCount:0, symbol:''}))+"\n    ")]}}])})],1),_vm._v(" "),_c('b-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>_vm.perPage && _vm.perPage>0),expression:"items.length>perPage && perPage>0"}],staticClass:"justify-content-center",attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectivenessTable_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd97462_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EffectivenessTable_vue__ = __webpack_require__(851);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectivenessTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bd97462_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EffectivenessTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'fields', 'table-caption', 'symbol', 'per-page'],
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_0_vue_perfect_scrollbar___default.a
  },
  data: function data() {
    return {
      currentPage: 1
    };
  },

  methods: {}
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[_c('VuePerfectScrollbar',{staticClass:"team-table-holder"},[_c('b-table',{attrs:{"responsive":"","fields":_vm.fields,"items":_vm.items,"per-page":_vm.perPage,"current-page":_vm.currentPage},scopedSlots:_vm._u([{key:"cell(team)",fn:function(data){return [_vm._v("\n        "+_vm._s(data.item.team.name)+"\n      ")]}},{key:"cell(visits)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.visits,{fractionCount:0, symbol:''}))+"\n      ")]}},{key:"cell(sales)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.sales,{fractionCount:0, symbol:''}))+"\n      ")]}},{key:"cell(effectiveness)",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("currency")(data.item.effectiveness,{symbol:'%', symbolSpacing:false, symbolPosition:'back'}))+"\n      ")]}}])})],1),_vm._v(" "),_c('b-pagination',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>_vm.perPage && _vm.perPage>0),expression:"items.length>perPage && perPage>0"}],staticClass:"justify-content-center",attrs:{"total-rows":_vm.items.length,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-3 dashboard"},[(_vm.$auth.check(['dashboard.objectives']))?_c('b-card',{staticClass:"objective-cards",attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n      Objectivos\n      "),_c('span',{staticClass:"float-right form-inline"},[_c('b-form-select',{staticClass:"mr-2",attrs:{"options":_vm.objectivesZones,"size":"sm"},model:{value:(_vm.zone),callback:function ($$v) {_vm.zone=$$v},expression:"zone"}}),_vm._v(" "),_c('b-form-select',{staticClass:"mr-2",attrs:{"options":_vm.objectivesPeriods,"size":"sm"},model:{value:(_vm.selectedPeriod),callback:function ($$v) {_vm.selectedPeriod=$$v},expression:"selectedPeriod"}}),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.monthOptions,"size":"sm"},model:{value:(_vm.selectedMonth),callback:function ($$v) {_vm.selectedMonth=$$v},expression:"selectedMonth"}})],1)]),_vm._v(" "),_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"12","lg":"6","xl":"5"}},[_c('objectives-table',{attrs:{"items":_vm.mpgObjectives.liters,"per-page":0,"fields":_vm.objectiveFieldsWithQT,"show-remaining":true,"table-caption":"Litros / Gama","symbol":""}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6","xl":"4"}},[_c('objectives-table',{attrs:{"items":_vm.mpgObjectives.gsv,"per-page":0,"fields":_vm.objectiveFieldsWithQT,"table-caption":"GSV / Gama","symbol":"€"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"6","xl":"3"}},[_c('objectives-table',{attrs:{"items":_vm.mpgObjectives.operators6,"per-page":0,"fields":_vm.objectiveFieldsWithBalance,"show-remaining":true,"table-caption":"LEs com compra >=6 / Gama","symbol":""}})],1),_vm._v(" "),(false)?_c('b-col',{attrs:{"sm":"12","lg":"6","xl":"3"}},[_c('objectives-table',{attrs:{"items":_vm.mpgObjectives.operators,"per-page":0,"fields":_vm.objectiveFields,"table-caption":"LEs com compra / Gama","symbol":""}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$auth.check(['dashboard.accounts']))?_c('b-row',[_c('b-col',{attrs:{"lg":"3"}},[_c('b-card',{attrs:{"no-body":true}},[_c('div',{staticClass:"card-body p-3 clearfix"},[_c('i',{staticClass:"fa fa-calculator bg-secondary font-2xl p-3 mr-3 float-left"}),_vm._v(" "),_c('div',{staticClass:"h5 mb-0 mt-2"},[_vm._v(_vm._s(_vm._f("currency")(_vm.accounts.sold,{fractionCount:0,symbolPosition:'back'})))]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase font-weight-bold font-xs"},[_vm._v("faturado últimos 30 dias")])])])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-card',{attrs:{"no-body":true}},[_c('div',{staticClass:"card-body p-3 clearfix"},[_c('i',{staticClass:"fa fa-calculator bg-secondary font-2xl p-3 mr-3 float-left"}),_vm._v(" "),_c('div',{staticClass:"h5 mb-0 mt-2"},[_vm._v(_vm._s(_vm._f("currency")(_vm.accounts.soldwtax,{fractionCount:0,symbolPosition:'back'})))]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase font-weight-bold font-xs"},[_vm._v("faturado últimos 30 dias com IVA")])])])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-card',{attrs:{"no-body":true}},[_c('div',{staticClass:"card-body p-3 clearfix"},[(_vm.accounts.open_variant==='success')?_c('i',{class:'fa fa-check  p-3 font-2xl mr-3 float-left bg-'+_vm.accounts.open_variant}):_vm._e(),_vm._v(" "),(_vm.accounts.open_variant!=='success')?_c('i',{class:'fa fa-times  p-3 font-2xl mr-3 float-left bg-'+_vm.accounts.open_variant}):_vm._e(),_vm._v(" "),_c('div',{class:'h5 mb-0 mt-2  text-'+_vm.accounts.open_variant},[_vm._v(_vm._s(_vm._f("currency")(_vm.accounts.open_value))+" "),_c('span',{staticClass:"small"},[_vm._v("("+_vm._s(_vm._f("currency")(_vm.accounts.open_percent,{symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}))+")")])]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase font-weight-bold font-xs"},[_vm._v("Valor em aberto "),_c('span',{staticClass:"small"},[_vm._v("(max "+_vm._s(_vm._f("currency")(_vm.accounts.open_objective,{symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}))+")")])])])])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-card',{attrs:{"no-body":true}},[_c('div',{staticClass:"card-body p-3 clearfix"},[(_vm.accounts.expired_variant==='success')?_c('i',{class:'fa fa-check  p-3 font-2xl mr-3 float-left bg-'+_vm.accounts.expired_variant}):_vm._e(),_vm._v(" "),(_vm.accounts.expired_variant!=='success')?_c('i',{class:'fa fa-times  p-3 font-2xl mr-3 float-left bg-'+_vm.accounts.expired_variant}):_vm._e(),_vm._v(" "),_c('div',{class:'h5 mb-0 mt-2  text-'+_vm.accounts.expired_variant},[_vm._v(_vm._s(_vm._f("currency")(_vm.accounts.expired_value))+" "),_c('span',{staticClass:"small"},[_vm._v("("+_vm._s(_vm._f("currency")(_vm.accounts.expired_percent,{symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}))+")")])]),_vm._v(" "),_c('div',{staticClass:"text-muted text-uppercase font-weight-bold font-xs"},[_vm._v("Valor vencido "),_c('span',{staticClass:"small"},[_vm._v("(max "+_vm._s(_vm._f("currency")(_vm.accounts.expired_objective,{symbol:'%',fractionCount:0,symbolPosition:'back',symbolSpacing:false}))+")")])])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[(_vm.$auth.check(['dashboard.objectives']))?_c('b-col',{attrs:{"sm":"12","lg":"6"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n          Litros por LE\n          "),_c('span',{staticClass:"float-right"},[_c('b-form-select',{attrs:{"options":_vm.monthOptions,"size":"sm"},model:{value:(_vm.selectedMonthLitersLE),callback:function ($$v) {_vm.selectedMonthLitersLE=$$v},expression:"selectedMonthLitersLE"}})],1)]),_vm._v(" "),_c('objectives-table',{attrs:{"items":_vm.litersLE,"fields":_vm.objectiveFieldsLE,"table-caption":"","symbol":""}})],1)],1):_vm._e(),_vm._v(" "),(_vm.$auth.check(['dashboard.effectiveness']))?_c('b-col',{attrs:{"sm":"6"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n          Efetividade de visitas\n          "),_c('span',{staticClass:"float-right"},[_vm._v("últimos 30 dias")])]),_vm._v(" "),_c('EffectivenessTable',{attrs:{"fields":_vm.effectivenessFields,"items":_vm.effectiveness,"per-page":0}})],1)],1):_vm._e()],1),_vm._v(" "),(_vm.$auth.check(['dashboard.last_updated']))?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n          Últimas atualizações\n        ")]),_vm._v(" "),_c('b-row',_vm._l((_vm.lastUpdate),function(item,index){return _c('b-col',{key:index,attrs:{"sm":"4"}},[_c('div',{staticClass:"p-2"},[_c('strong',[_vm._v(_vm._s(item.tablename))]),_vm._v(": "+_vm._s(_vm.$moment(item.last_update).calendar())+"\n            ")])])}),1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_targets_vue__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500af641_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_targets_vue__ = __webpack_require__(904);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_targets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500af641_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_targets_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray__);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'targets',

  data: function data() {
    return {
      isInitializing: true,
      zone: null,
      selectedPeriod: 1,
      selectedMonth: null,
      selectedDSR: null,
      selectedRoutine: null,
      accStartMonth: null,
      accEndMonth: null,
      objectivesZones: [],
      objectivesPeriods: [{ value: 1, text: 'Por mês' }, { value: 2, text: 'Acumulado' }],
      monthOptions: [],
      dsrOptions: [],
      routineOptions: [],

      mpgObjectives: {
        liters: [],
        gsv: [],
        operators6: []
      },

      objectiveFieldsWithQT: [{ key: 'name', label: 'Gama' }, { key: 'objective_value', label: 'Objectivo' }, { key: 'current', label: 'Realizado' }, { key: 'progress', label: 'Progresso' }, { key: 'remaining', label: 'QT' }],

      objectiveFieldsWithBalance: [{ key: 'name', label: 'Gama' }, { key: 'objective_value', label: 'Objectivo' }, { key: 'current', label: 'Realizado' }, { key: 'progress', label: 'Progresso' }, { key: 'balance', label: 'Saldo' }],

      dsrFields: [{ key: 'name', label: 'Gama' }, { key: 'objective_value', label: 'Objectivo' }, { key: 'current', label: 'Realizado' }, { key: 'progress', label: 'Progresso', formatter: function formatter(v) {
          return v + '%';
        } }, { key: 'quantity', label: 'QT' }],

      dsrObjectives: {
        liters: [],
        gsv: [],
        operators6: []
      },
      selectedDSRMonth: null,
      dsrDateStart: null,
      dsrDateEnd: null,
      allRoutineOptions: [],
      routinesByDsr: {},
      dsrLoading: {
        liters: false,
        gsv: false,
        operators6: false
      }
    };
  },


  watch: {
    zone: function zone() {
      if (!this.zone || this.isInitializing) return;

      this.selectedDSR = null;
      this.selectedRoutine = null;

      this.loadDSRAndRoutines();
    },
    selectedPeriod: function selectedPeriod() {
      if (this.selectedPeriod === 1) {
        this.accStartMonth = null;
        this.accEndMonth = null;
      }

      if (this.selectedPeriod === 2) {
        this.selectedDSRMonth = null;
      }
    },
    accStartMonth: function accStartMonth() {
      this.updateAccumulatedDates();
    },
    accEndMonth: function accEndMonth() {
      this.updateAccumulatedDates();
    },
    selectedDSRMonth: function selectedDSRMonth(val) {
      if (!val) {
        this.dsrDateStart = null;
        this.dsrDateEnd = null;
        return;
      }

      var _val$split$map = val.split('-').map(Number),
          _val$split$map2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_val$split$map, 2),
          year = _val$split$map2[0],
          month = _val$split$map2[1];

      var start = new Date(year, month - 1, 1);

      var end = new Date(year, month, 0);

      this.dsrDateStart = this.formatDateLocal(start);
      this.dsrDateEnd = this.formatDateLocal(end);
    },
    selectedDSR: function selectedDSR(val) {
      if (!val) {
        this.routineOptions = this.allRoutineOptions;
        this.selectedRoutine = null;
        return;
      }
      var routines = this.routinesByDsr[val] || [];
      this.routineOptions = [{ value: null, text: 'Todas' }].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()([].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(routines)).map(function (r) {
        return { value: r, text: r };
      })));

      this.selectedRoutine = null;
    }
  },

  methods: {
    applyFilters: function applyFilters() {
      this.loadDashboardObjectives();
      this.loadDSRTargets();
    },
    formatDateLocal: function formatDateLocal(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    sumTargetsByMpgCode: function sumTargetsByMpgCode(targets) {
      var map = {};

      targets.forEach(function (t) {
        if (!t.mpg_code) return;

        if (!map[t.mpg_code]) {
          map[t.mpg_code] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, t, {
            objective_value: Number(t.objective_value || 0)
          });
        } else {
          map[t.mpg_code].objective_value += Number(t.objective_value || 0);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(map);
    },
    updateAccumulatedDates: function updateAccumulatedDates() {
      if (!this.accStartMonth || !this.accEndMonth) return;

      var _accStartMonth$split$ = this.accStartMonth.split('-').map(Number),
          _accStartMonth$split$2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_accStartMonth$split$, 1),
          startYear = _accStartMonth$split$2[0];

      var _accEndMonth$split$ma = this.accEndMonth.split('-').map(Number),
          _accEndMonth$split$ma2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_accEndMonth$split$ma, 2),
          endYear = _accEndMonth$split$ma2[0],
          endMonth = _accEndMonth$split$ma2[1];

      var startDate = void 0,
          endDate = void 0;

      if (this.selectedPeriod === 2) {
        startDate = new Date(startYear, 0, 1);

        endDate = new Date(endYear, endMonth, 0);
      }

      this.dsrDateStart = this.formatDateLocal(startDate);
      this.dsrDateEnd = this.formatDateLocal(endDate);
    },
    rowClass: function rowClass(item) {
      if (!item || item.progress == null) return '';

      return item.progress >= 100 ? 'table-success' : 'table-danger';
    },
    loadDashboardObjectives: function loadDashboardObjectives() {
      var _this = this;

      if (!this.selectedMonth || !this.zone) return;
      ['liters', 'gsv', 'operators6'].forEach(function (type) {
        _this.loadObjectives(type, _this.selectedPeriod, _this.selectedMonth, _this.zone);
      });
    },
    loadObjectives: function loadObjectives(type, period, dts, zone) {
      var _this2 = this;

      var data = {
        analysisType: period,
        rows: 'products',
        subrows: 'mpg_id',
        presetdate: 'custom',
        datetype: 'y',
        year: dts.year,
        clientType: 'F',
        docType: 'AGR',
        dates: {
          start: { day: dts.start, month: dts.month },
          end: { day: dts.end, month: dts.month }
        },
        zone: zone
      };

      if (period === 2) {
        data.dates.start = { day: 1, month: 1 };
      }

      this.axios.post('dashboard/mpg_objectives/' + type + '/' + dts.year_month, data).then(function (res) {
        _this2.mpgObjectives[type] = res.data.data;
      });
    },
    loadDSRAndRoutines: function loadDSRAndRoutines() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _getCurrentMonthRange, ini, fin, zoneParam, types, requests, responses, dsrMap, routineSet;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.zone) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _getCurrentMonthRange = _this3.getCurrentMonthRange(), ini = _getCurrentMonthRange.ini, fin = _getCurrentMonthRange.fin;


                _this3.routinesByDsr = {};
                _this3.dsrOptions = [];
                _this3.routineOptions = [];

                zoneParam = _this3.zone === 'ccss' ? 'ccss-objective' : _this3.zone;
                types = ['liters', 'gsv', 'operators6'];
                requests = types.map(function (type) {
                  return _this3.axios.get('objectives/getRealRotines', {
                    params: {
                      type: type,
                      year_month_ini: ini,
                      year_month_fin: fin,
                      zone: zoneParam
                    }
                  });
                });
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(requests);

              case 11:
                responses = _context.sent;
                dsrMap = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();
                routineSet = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();


                responses.forEach(function (res) {
                  res.data.forEach(function (r) {
                    if (r.salesteam_id && !dsrMap.has(r.salesteam_id)) {
                      dsrMap.set(r.salesteam_id, {
                        value: r.salesteam_id,
                        text: r.salesteam_name
                      });
                    }

                    if (r.routine_code) {
                      routineSet.add(r.routine_code);

                      if (!_this3.routinesByDsr[r.salesteam_id]) {
                        _this3.routinesByDsr[r.salesteam_id] = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
                      }

                      _this3.routinesByDsr[r.salesteam_id].add(r.routine_code);
                    }
                  });
                });

                _this3.dsrOptions = [{ value: null, text: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(dsrMap.values())));

                _this3.allRoutineOptions = [{ value: null, text: 'Todas' }].concat(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(routineSet).map(function (r) {
                  return {
                    value: r,
                    text: r
                  };
                })));

                _this3.routineOptions = _this3.allRoutineOptions;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    generateMonthPeriods: function generateMonthPeriods(startMonth, endMonth) {
      var periods = [];

      var _startMonth$split$map = startMonth.split('-').map(Number),
          _startMonth$split$map2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_startMonth$split$map, 2),
          startYear = _startMonth$split$map2[0],
          startM = _startMonth$split$map2[1];

      var _endMonth$split$map = endMonth.split('-').map(Number),
          _endMonth$split$map2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_endMonth$split$map, 2),
          endYear = _endMonth$split$map2[0],
          endM = _endMonth$split$map2[1];

      var year = startYear;
      var month = startM;

      while (year < endYear || year === endYear && month <= endM) {
        var firstDay = new Date(year, month - 1, 1);
        var lastDay = new Date(year, month, 0);

        periods.push({
          ini: this.formatDateLocal(firstDay),
          fin: this.formatDateLocal(lastDay)
        });

        month++;

        if (month > 12) {
          month = 1;
          year++;
        }
      }

      return periods;
    },
    buildAccumulatedTable: function buildAccumulatedTable(type, currentReal, pastReal, targets) {
      var _this4 = this;

      var groupByMonth = function groupByMonth(data) {
        var map = {};
        data.forEach(function (r) {
          if (!map[r.year_month]) map[r.year_month] = [];
          map[r.year_month].push(r);
        });
        return map;
      };

      var currentByMonth = groupByMonth(currentReal);

      var pastByMonthShifted = {};
      pastReal.forEach(function (r) {
        var shiftedMonth = r.year_month + 100;

        if (!pastByMonthShifted[shiftedMonth]) {
          pastByMonthShifted[shiftedMonth] = [];
        }

        pastByMonthShifted[shiftedMonth].push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, r, {
          year_month: shiftedMonth
        }));
      });

      var targetsByMonth = {};
      targets.forEach(function (t) {
        if (!targetsByMonth[t.year_month]) {
          targetsByMonth[t.year_month] = {};
        }
        targetsByMonth[t.year_month][t.mpg_code] = t;
      });

      var aggregated = {};

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(targetsByMonth).forEach(function (month) {
        var currentMap = _this4.sumByMpgCode(currentByMonth[month] || []);
        var pastMap = _this4.sumByMpgCode(pastByMonthShifted[month] || []);

        var perBoxMap = type === 'liters' ? _this4.sumPerBoxByMpgCode(currentByMonth[month] || []) : {};

        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(targetsByMonth[month]).forEach(function (t) {
          var code = t.mpg_code;

          if (!aggregated[code]) {
            aggregated[code] = {
              name: t.mpg_name || code,
              current: 0,
              objective_value: 0,
              quantity: 0
            };
          }

          var current = currentMap[code] || 0;
          var past = pastMap[code] || 0;

          var objective = past + past * (t.target || 0) / 100;

          aggregated[code].current += current;
          aggregated[code].objective_value += objective;

          if (type === 'liters') {
            var perBox = perBoxMap[code] || 0;

            if (current <= objective && perBox) {
              aggregated[code].quantity += -1 * ((objective - current) / perBox);
            }
          }

          if (type === 'operators6') {
            aggregated[code].quantity += current - objective;
          }
        });
      });

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_values___default()(aggregated).map(function (row) {
        var current = Number(row.current.toFixed(0));
        var objective = Number(row.objective_value.toFixed(0));

        var progress = objective === 0 ? 0 : Number((current / objective * 100).toFixed(1));

        return {
          name: row.name,
          current: current,
          objective_value: objective,
          progress: progress,
          quantity: type === 'gsv' ? null : Number(row.quantity.toFixed(0))
        };
      });
    },
    loadDSRTargets: function loadDSRTargets() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var period, types, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type, hasFilter, currentReal, pastReal, targets, _pastPeriod, pastPeriod, finalTargets;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.zone) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                period = null;

                if (!(_this5.selectedPeriod === 1)) {
                  _context2.next = 7;
                  break;
                }

                if (_this5.selectedDSRMonth) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:

                period = {
                  ini: _this5.dsrDateStart,
                  fin: _this5.dsrDateEnd
                };

              case 7:
                if (!(_this5.selectedPeriod === 2)) {
                  _context2.next = 14;
                  break;
                }

                if (!(!_this5.accStartMonth || !_this5.accEndMonth)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                if (!(_this5.accStartMonth > _this5.accEndMonth)) {
                  _context2.next = 13;
                  break;
                }

                alert('Mês de início tem de ser inferior ao mês final');
                return _context2.abrupt('return');

              case 13:

                period = {
                  ini: _this5.dsrDateStart,
                  fin: _this5.dsrDateEnd
                };

              case 14:
                types = ['liters', 'gsv', 'operators6'];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 18;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(types);

              case 20:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 68;
                  break;
                }

                type = _step.value;

                _this5.dsrObjectives[type] = [];
                _this5.dsrLoading[type] = true;

                _context2.prev = 24;
                hasFilter = !!_this5.selectedDSR || !!_this5.selectedRoutine;
                currentReal = [];
                pastReal = [];
                targets = [];

                if (!(_this5.selectedPeriod === 2 && type !== 'operators6' && hasFilter)) {
                  _context2.next = 42;
                  break;
                }

                _context2.next = 32;
                return _this5.fetchRealized(type, period);

              case 32:
                currentReal = _context2.sent;
                _pastPeriod = {
                  ini: _this5.shiftYear(period.ini, -1),
                  fin: _this5.shiftYear(period.fin, -1)
                };
                _context2.next = 36;
                return _this5.fetchRealized(type, _pastPeriod);

              case 36:
                pastReal = _context2.sent;
                _context2.next = 39;
                return _this5.fetchTargets(type, period);

              case 39:
                targets = _context2.sent;


                _this5.dsrObjectives[type] = _this5.buildAccumulatedTable(type, currentReal, pastReal, targets);

                return _context2.abrupt('continue', 65);

              case 42:
                _context2.next = 44;
                return _this5.fetchRealized(type, period);

              case 44:
                currentReal = _context2.sent;
                pastPeriod = {
                  ini: _this5.shiftYear(period.ini, -1),
                  fin: _this5.shiftYear(period.fin, -1)
                };
                _context2.next = 48;
                return _this5.fetchRealized(type, pastPeriod);

              case 48:
                pastReal = _context2.sent;
                _context2.next = 51;
                return _this5.fetchTargets(type, period);

              case 51:
                targets = _context2.sent;
                finalTargets = targets;


                if (_this5.selectedPeriod === 2 && type !== 'operators6') {
                  finalTargets = _this5.sumTargetsByMpgCode(targets);
                }

                if (type === 'operators6' && _this5.selectedPeriod === 2) {
                  (function () {
                    var _accEndMonth$split$ma3 = _this5.accEndMonth.split('-').map(Number),
                        _accEndMonth$split$ma4 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_accEndMonth$split$ma3, 2),
                        endYear = _accEndMonth$split$ma4[0],
                        endMonth = _accEndMonth$split$ma4[1];

                    var selectedYearMonth = endYear * 100 + endMonth;
                    finalTargets = targets.filter(function (r) {
                      return r.year_month === selectedYearMonth;
                    });
                  })();
                }

                _this5.dsrObjectives[type] = _this5.buildDsrTable(type, currentReal, pastReal, finalTargets);
                _context2.next = 62;
                break;

              case 58:
                _context2.prev = 58;
                _context2.t0 = _context2['catch'](24);

                console.error('Error loading DSR targets for ' + type, _context2.t0);
                _this5.dsrObjectives[type] = [];

              case 62:
                _context2.prev = 62;

                _this5.dsrLoading[type] = false;
                return _context2.finish(62);

              case 65:
                _iteratorNormalCompletion = true;
                _context2.next = 20;
                break;

              case 68:
                _context2.next = 74;
                break;

              case 70:
                _context2.prev = 70;
                _context2.t1 = _context2['catch'](18);
                _didIteratorError = true;
                _iteratorError = _context2.t1;

              case 74:
                _context2.prev = 74;
                _context2.prev = 75;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 77:
                _context2.prev = 77;

                if (!_didIteratorError) {
                  _context2.next = 80;
                  break;
                }

                throw _iteratorError;

              case 80:
                return _context2.finish(77);

              case 81:
                return _context2.finish(74);

              case 82:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[18, 70, 74, 82], [24, 58, 62, 65], [75,, 77, 81]]);
      }))();
    },
    shiftYear: function shiftYear(dateStr, diff) {
      var d = new Date(dateStr);
      d.setFullYear(d.getFullYear() + diff);
      return d.toISOString().slice(0, 10);
    },
    fetchRealized: function fetchRealized(type, period) {
      var params = {
        type: type,
        year_month_ini: period.ini,
        year_month_fin: period.fin
      };
      if (this.zone) {
        if (this.zone === 'ccss') {
          params.zone = 'ccss-objective';
        } else {
          params.zone = this.zone;
        }
      }

      if (this.selectedDSR) {
        params.salesteam_id = this.selectedDSR;
      }

      if (this.selectedRoutine) {
        params.routine_code = this.selectedRoutine;
      }

      return this.axios.get('objectives/getRealRotines', { params: params }).then(function (res) {
        return res.data;
      });
    },
    fetchTargets: function fetchTargets(type, period) {
      var params = {
        type: type,
        zone: this.zone
      };

      params.year_month_ini = period.ini;
      params.year_month_fin = period.fin;

      var selectedYearMonth = null;
      if (type === 'operators6' && this.selectedPeriod === 1 && this.selectedDSRMonth) {
        var _selectedDSRMonth$spl = this.selectedDSRMonth.split('-').map(Number),
            _selectedDSRMonth$spl2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_slicedToArray___default()(_selectedDSRMonth$spl, 2),
            year = _selectedDSRMonth$spl2[0],
            month = _selectedDSRMonth$spl2[1];

        var startOfYear = new Date(year, 0, 1);
        var endOfMonth = new Date(year, month, 0);
        params.year_month_ini = startOfYear.toISOString().slice(0, 10);
        params.year_month_fin = endOfMonth.toISOString().slice(0, 10);

        selectedYearMonth = year * 100 + month;
      }

      if (this.selectedDSR) {
        params.salesteam_id = this.selectedDSR;
      }

      if (this.selectedRoutine) {
        params.routine_code = this.selectedRoutine;
      }

      return this.axios.get('objectives/getTarget', { params: params }).then(function (res) {
        var data = res.data;

        if (type === 'operators6' && selectedYearMonth) {
          data = data.filter(function (r) {
            return r.year_month === selectedYearMonth;
          });
        }

        return data;
      });
    },
    sumByMpgCode: function sumByMpgCode(data) {
      var map = {};
      data.forEach(function (r) {
        map[r.mpg_code] = (map[r.mpg_code] || 0) + Number(r.value || 0);
      });
      return map;
    },
    sumPerBoxByMpgCode: function sumPerBoxByMpgCode(data) {
      var map = {};

      data.forEach(function (r) {
        var liters = Number(r.value || 0);
        var perBox = Number(r.per_box || 0);

        if (!perBox) return;

        var quantity = liters / perBox;

        if (!map[r.mpg_code]) {
          map[r.mpg_code] = {
            liters: 0,
            quantity: 0
          };
        }

        map[r.mpg_code].liters += liters;
        map[r.mpg_code].quantity += quantity;
      });

      var result = {};

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(map).forEach(function (code) {
        var row = map[code];

        result[code] = row.quantity === 0 ? 0 : row.liters / row.quantity;
      });

      return result;
    },
    buildDsrTable: function buildDsrTable(type, currentReal, pastReal, targets) {
      var _this6 = this;

      var currentMap = this.sumByMpgCode(currentReal);
      var pastMap = this.sumByMpgCode(pastReal);

      var perBoxMap = type === 'liters' ? this.sumPerBoxByMpgCode(currentReal) : {};

      var hasFilter = !!this.selectedDSR || !!this.selectedRoutine;

      return targets.map(function (t) {
        if (!t.mpg_name) return null;

        if (!t.mpg_name) {
          console.warn('Missing mpg_name for target:', t);
        }

        if (!currentMap[t.mpg_code]) {
          console.warn('Missing current for mpg_code:', t.mpg_code);
        }

        console.log('Targets count:', targets.length);
        console.log('Unique mpg_codes:', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this6.sumByMpgCode(currentReal)).length);

        var current = Number((currentMap[t.mpg_code] || 0).toFixed(0));
        var past = pastMap[t.mpg_code] || 0;

        var objective = 0;

        if (hasFilter) {
          objective = past + past * (t.target || 0) / 100;
        } else {
          objective = Number(t.objective_value || 0);
        }

        objective = Number(objective.toFixed(0));

        var progress = objective === 0 ? 0 : Number((current / objective * 100).toFixed(1));

        var quantity = null;

        if (type === 'operators6') {
          quantity = Number((current - objective).toFixed(0));
        }

        if (type === 'liters') {
          var perBox = perBoxMap[t.mpg_code] || 0;

          if (current > objective) {
            quantity = 0;
          } else if (perBox !== 0) {
            quantity = -1 * Number(((objective - current) / perBox).toFixed(0));
          } else {
            quantity = 0;
          }
        }

        return {
          name: t.mpg_name,
          current: current,
          objective_value: objective,
          progress: progress,
          quantity: quantity,
          perBox: perBoxMap[t.mpg_code] || 0
        };
      }).filter(Boolean);
    },
    getCurrentMonthRange: function getCurrentMonthRange() {
      var now = new Date();

      var start = new Date(now.getFullYear(), now.getMonth(), 1);
      var end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      return {
        ini: this.formatDateLocal(start),
        fin: this.formatDateLocal(end)
      };
    }
  },

  created: function created() {
    var _this7 = this;

    this.axios.get('dashboard/objectives').then(function (res) {
      _this7.monthOptions = res.data.data.months;
      _this7.objectivesZones = res.data.data.zones;

      _this7.zone = _this7.objectivesZones && _this7.objectivesZones.length > 0 ? _this7.objectivesZones[0].value : null;

      _this7.selectedMonth = _this7.monthOptions && _this7.monthOptions.length > 1 ? _this7.monthOptions[1] : null;

      _this7.isInitializing = false;

      _this7.loadDashboardObjectives();
    });
  }
});

/***/ }),
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-3 dashboard"},[_c('b-card',{staticClass:"objective-cards",attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n      Objectivos\n    ")]),_vm._v(" "),_c('b-card-body',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"px-1 mb-1",attrs:{"cols":"12","sm":"2","md":"auto"}},[_c('b-form-select',{attrs:{"options":_vm.objectivesZones,"size":"sm"},model:{value:(_vm.zone),callback:function ($$v) {_vm.zone=$$v},expression:"zone"}})],1),_vm._v(" "),_c('b-col',{staticClass:"px-1 mb-1",attrs:{"cols":"12","sm":"2","md":"auto"}},[_c('b-form-select',{attrs:{"options":_vm.dsrOptions,"value-field":"value","text-field":"text","size":"sm"},model:{value:(_vm.selectedDSR),callback:function ($$v) {_vm.selectedDSR=$$v},expression:"selectedDSR"}})],1),_vm._v(" "),_c('b-col',{staticClass:"px-1 mb-1",attrs:{"cols":"12","sm":"2","md":"auto"}},[_c('b-form-select',{attrs:{"options":_vm.routineOptions,"size":"sm"},model:{value:(_vm.selectedRoutine),callback:function ($$v) {_vm.selectedRoutine=$$v},expression:"selectedRoutine"}})],1),_vm._v(" "),_c('b-col',{staticClass:"px-1 mb-1",attrs:{"cols":"12","sm":"2","md":"auto"}},[_c('b-form-select',{attrs:{"options":_vm.objectivesPeriods,"size":"sm"},model:{value:(_vm.selectedPeriod),callback:function ($$v) {_vm.selectedPeriod=$$v},expression:"selectedPeriod"}})],1),_vm._v(" "),(_vm.selectedPeriod === 1)?_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDSRMonth),expression:"selectedDSRMonth"}],staticClass:"form-control form-control-sm",attrs:{"type":"month"},domProps:{"value":(_vm.selectedDSRMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDSRMonth=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.selectedPeriod === 2)?_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accStartMonth),expression:"accStartMonth"}],staticClass:"form-control form-control-sm",attrs:{"type":"month"},domProps:{"value":(_vm.accStartMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accStartMonth=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.selectedPeriod === 2)?_c('b-col',{attrs:{"cols":"12","sm":"2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accEndMonth),expression:"accEndMonth"}],staticClass:"form-control form-control-sm",attrs:{"type":"month"},domProps:{"value":(_vm.accEndMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.accEndMonth=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.applyFilters}},[_vm._v("\n            Aplicar filtros\n          ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"5"}},[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"font-weight-bold text-center"},[_vm._v("\n                Litros / DSR\n              ")])]},proxy:true}])},[_vm._v(" "),_c('b-overlay',{attrs:{"show":_vm.dsrLoading.liters,"rounded":"","opacity":"0.6","spinner-variant":"primary"}},[_c('b-table',{attrs:{"small":"","bordered":"","striped":"","responsive":"","items":_vm.dsrObjectives.liters,"fields":_vm.dsrFields,"tbody-tr-class":_vm.rowClass,"show-empty":""}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"font-weight-bold text-center"},[_vm._v("\n                GSV / DSR\n              ")])]},proxy:true}])},[_vm._v(" "),_c('b-overlay',{attrs:{"show":_vm.dsrLoading.gsv,"rounded":"","opacity":"0.6","spinner-variant":"primary"}},[_c('b-table',{attrs:{"small":"","bordered":"","striped":"","responsive":"","items":_vm.dsrObjectives.gsv,"fields":_vm.dsrFields,"tbody-tr-class":_vm.rowClass,"show-empty":""}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"font-weight-bold text-center"},[_vm._v("\n                LEs ≥ 6 / DSR\n              ")])]},proxy:true}])},[_vm._v(" "),_c('b-overlay',{attrs:{"show":_vm.dsrLoading.operators6,"rounded":"","opacity":"0.6","spinner-variant":"primary"}},[_c('b-table',{attrs:{"small":"","bordered":"","striped":"","responsive":"","items":_vm.dsrObjectives.operators6,"fields":_vm.dsrFields,"tbody-tr-class":_vm.rowClass,"show-empty":""}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bc518a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__ = __webpack_require__(939);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62bc518a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Statistics',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'accounts',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        rows: 'client_id',
        presetdate: 'all',
        datetype: 'y',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('accounts/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#accounts-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('accounts/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'accounts.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'accounts.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'accounts.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'accounts/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Filters_MpgFilter_vue__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Filters_BrandFilter_vue__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Filters_CoreFilter_vue__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Filters_ProdAgregFilter_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Filters_ProductFilter_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Filters_ClientFilter_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Filters_RoutineFilter_vue__ = __webpack_require__(443);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  components: {
    Mpg: __WEBPACK_IMPORTED_MODULE_1__views_Filters_MpgFilter_vue__["a" /* default */],
    GeneralFilter: __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__["a" /* default */],
    Brand: __WEBPACK_IMPORTED_MODULE_2__views_Filters_BrandFilter_vue__["a" /* default */],
    ProdAgreg: __WEBPACK_IMPORTED_MODULE_4__views_Filters_ProdAgregFilter_vue__["a" /* default */],
    Core: __WEBPACK_IMPORTED_MODULE_3__views_Filters_CoreFilter_vue__["a" /* default */],
    Product: __WEBPACK_IMPORTED_MODULE_5__views_Filters_ProductFilter_vue__["a" /* default */],
    Routine: __WEBPACK_IMPORTED_MODULE_7__views_Filters_RoutineFilter_vue__["a" /* default */],
    Client: __WEBPACK_IMPORTED_MODULE_6__views_Filters_ClientFilter_vue__["a" /* default */]
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data: function data() {
    return {
      type: null,
      name: ''
    };
  },

  methods: {
    changedFilter: function changedFilter(field, name) {
      this.type = field;
      this.name = name;
    },
    addFilter: function addFilter(evt) {
      var start = window.performance.now();
      console.log('event received', start);
      var found = false;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          });
          found = true;
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          });
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          });
        }
      }
      console.log('added to list', window.performance.now());
      console.log('added to list elapsed', window.performance.now() - start);
    },
    removeFilter: function removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1);
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1);
          }
        }
      }
    },
    removeAllFilters: function removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = [];
          this.readOptions.filters[i].excludes = [];
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GeneralFilter',
  props: ['height', 'field', 'url', 'name', 'refName'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.refName].$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: this.field,
        item: dataItem,
        title: this.name,
        'type': 'includes'
      });
    },
    addExpurgeFilter: function addExpurgeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.refName].$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: this.field,
        item: dataItem,
        title: this.name,
        'type': 'expurges'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.refName].$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: this.field,
        item: dataItem,
        title: this.name,
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:_vm.refName,attrs:{"name":_vm.refName,"url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MpgFilter_vue__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d0ad98_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MpgFilter_vue__ = __webpack_require__(912);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MpgFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90d0ad98_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MpgFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mpg',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'mpgs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridMpg.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'mpg_id',
        item: dataItem,
        title: 'MPG',
        'type': 'includes'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridMpg.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'mpg_id',
        item: dataItem,
        title: 'MPG',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridMpg",attrs:{"name":"filterGridMpg","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandFilter_vue__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f109452_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BrandFilter_vue__ = __webpack_require__(915);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrandFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f109452_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BrandFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Brand',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'brands',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridBrand.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'brand_id',
        item: dataItem,
        title: 'Brand',
        'type': 'includes'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridBrand.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'brand_id',
        item: dataItem,
        title: 'Brand',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridBrand",attrs:{"name":"filterGridBrand","url":_vm.url,"columns":_vm.columns,"pageable":false,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoreFilter_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f2e2f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CoreFilter_vue__ = __webpack_require__(918);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoreFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f2e2f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CoreFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Core',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'cores',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'includes'
      });
    },
    addExpurgeFilter: function addExpurgeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'expurges'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridCore.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'core_id',
        item: dataItem,
        title: 'Core',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridCore",attrs:{"name":"filterGridCore","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProdAgreg',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'prodagregs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      console.log('click', window.performance.now());
      var grid = this.$refs.filterGridProdAgreg.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      console.log('emit', window.performance.now());
      this.$emit('added-filter', {
        field: 'product_aggregator_id',
        item: dataItem,
        title: 'Prodagreg',
        'type': 'includes'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridProdAgreg.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'product_aggregator_id',
        item: dataItem,
        title: 'Prodagreg',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridProdAgreg",attrs:{"name":"filterGridProdAgreg","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilter_vue__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2247dd3f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilter_vue__ = __webpack_require__(923);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2247dd3f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProductFilter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Product',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [{
        field: 'core_id',
        api: 'cores/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'mpg_id',
        api: 'mpgs/lst'
      }, {
        field: 'product_aggregator_id',
        api: 'prodagregs/lst'
      }],
      schemaModelFields: {},
      url: 'products',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'sku',
        title: 'Sku'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'product_aggregator_id',
        title: 'ProdAgreg',
        width: '200px'
      }, {
        field: 'core_id',
        title: 'Core',
        width: '200px'
      }, {
        field: 'brand_id',
        title: 'Brand',
        width: '200px'
      }, {
        field: 'mpg_id',
        title: 'Mpg',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'includes'
      });
    },
    addExpurgeFilter: function addExpurgeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'expurges'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridProduct.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'product_id',
        item: dataItem,
        title: 'Product',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridProduct",attrs:{"name":"filterGridProduct","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'clients',
      columns: [{
        'title': '',
        width: '100px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '100px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'nif',
        title: 'NIF'
      }, {
        width: '160px',
        field: 'name',
        title: 'Nome'
      }, {
        field: 'commercial_designation',
        title: 'Designação Comercial',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridClient.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'client_id',
        item: dataItem,
        title: 'Client',
        'type': 'includes'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs.filterGridClient.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: 'client_id',
        item: dataItem,
        title: 'Client',
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridClient",attrs:{"name":"filterGridClient","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filter',
  props: ['height', 'field', 'url', 'name', 'refName'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        field: 'routine_code',
        title: 'Rotina'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addIncludeFilter: function addIncludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.refName].$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: this.field,
        item: dataItem,
        title: this.name,
        'type': 'includes'
      });
    },
    addExcludeFilter: function addExcludeFilter(e) {
      e.preventDefault();
      var grid = this.$refs[this.refName].$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('added-filter', {
        field: this.field,
        item: dataItem,
        title: this.name,
        'type': 'excludes'
      });
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:_vm.refName,attrs:{"name":_vm.refName,"url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Filtros"}},[_c('div',{staticClass:"row filter-column"},[_c('div',{staticClass:"col-md",class:{ 'col-md-4': _vm.showFilterGrid }},[_c('b-card-group',{attrs:{"columns":""}},[(_vm.totalFilters===0)?_c('b-card',[_vm._v("\n          Sem filtros\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.readOptions.filters),function(filter){return _c('b-card',{directives:[{name:"show",rawName:"v-show",value:(filter.includes.length > 0 || filter.excludes.length > 0),expression:"filter.includes.length > 0 || filter.excludes.length > 0"}],key:filter.field,attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            "+_vm._s(filter.title)+"\n          ")]),_vm._v(" "),_c('b-list-group',[_vm._l((filter.includes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'includes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),_vm._v(" "),_vm._l((filter.excludes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'excludes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)})],2),_vm._v(" "),_c('b-card-footer',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"text-danger",on:{"click":function($event){return _vm.removeAllFilters(filter.field)}}},[_vm._v("Limpar filtros "),_c('i',{staticClass:"fa fa-ban"})])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"col-md-8"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.filters),function(filter){return _c('b-nav-item',{key:filter.value,attrs:{"active":_vm.type === filter.value},on:{"click":function($event){return _vm.changedFilter(filter.value, filter.name)}}},[_vm._v(_vm._s(filter.text))])}),1)],1),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'mpg_id'),expression:"type === 'mpg_id'"}],attrs:{"ref-name":"SFMpg","url":"mpgs","name":"MPG","field":"mpg_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'brand_id'),expression:"type === 'brand_id'"}],attrs:{"ref-name":"SFBrand","url":"brands","name":"Brand","field":"brand_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'core_id'),expression:"type === 'core_id'"}],attrs:{"ref-name":"SFCore","url":"cores","name":"Cores","field":"core_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('ProdAgreg',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_aggregator_id'),expression:"type === 'product_aggregator_id'"}],on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Product',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_id'),expression:"type === 'product_id'"}],on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Client',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'client_id'),expression:"type === 'client_id'"}],on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'origin_type'),expression:"type === 'origin_type'"}],attrs:{"ref-name":"SFOriginType","url":"orderstype","name":"Tipo de Encomenda","field":"origin_type"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'sale_point'),expression:"type === 'sale_point'"}],attrs:{"ref-name":"SFSalesPoint","url":"salepoints","name":"Ponto de Venda","field":"sale_point"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'zone'),expression:"type === 'zone'"}],attrs:{"ref-name":"SFZone","url":"zones","name":"Zona","field":"zone"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'operator_group_id'),expression:"type === 'operator_group_id'"}],attrs:{"ref-name":"SFOPGroup","url":"operatorgroups","name":"Operator Groups","field":"operator_group_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'activity_type_id'),expression:"type === 'activity_type_id'"}],attrs:{"ref-name":"SFActivity","url":"activities","name":"Ramo Actividade","field":"activity_type_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'location_id'),expression:"type === 'location_id'"}],attrs:{"ref-name":"SFLocation","url":"locations","name":"Localização","field":"location_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'visibility_id'),expression:"type === 'visibility_id'"}],attrs:{"ref-name":"SFVisibility","url":"visibilities","name":"Visibilidade","field":"visibility_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'segment_id'),expression:"type === 'segment_id'"}],attrs:{"ref-name":"SFSegment","url":"segments","name":"Segmentos","field":"segment_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'salesteam_id'),expression:"type === 'salesteam_id'"}],attrs:{"ref-name":"SFSalesTeam","url":"team","name":"Vendedores","field":"salesteam_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Routine',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'routine_code'),expression:"type === 'routine_code'"}],attrs:{"ref-name":"SFRoutine","url":"routines","name":"Rotina","field":"routine_code"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'salesteam_id2'),expression:"type === 'salesteam_id2'"}],attrs:{"ref-name":"SFSalesteam2","url":"team","name":"Vendedores 2","field":"salesteam_id2"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Routine',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'routine_code2'),expression:"type === 'routine_code2'"}],attrs:{"ref-name":"SFRoutine2","url":"routines2","name":"Rotina 2","field":"routine_code2"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'doc_type'),expression:"type === 'doc_type'"}],attrs:{"ref-name":"SFDoc","url":"documentTypes","name":"Tipo Documento","field":"doc_type"},on:{"added-filter":_vm.addFilter}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'queries',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'carregar',
          click: this.loadQuery
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'apagar',
          click: this.deleteQuery
        }
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    loadQuery: function loadQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('load-query', {
        item: dataItem
      });
    },
    deleteQuery: function deleteQuery(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.axios.delete('queries/' + dataItem.id).then(function (response) {
        grid.dataSource.read();
      });
    }
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"Contas correntes"}},[(!_vm.showResults)?_c('div',[(false)?_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.start.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "year", $$v)},expression:"readOptions.dates.start.year"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.end.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "year", $$v)},expression:"readOptions.dates.end.year"}})],1)])],1)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"accounts-results",attrs:{"id":"accounts-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'currentaccounts.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"accountsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"accountsGrid","url":_vm.url,"detail-url":"accounts","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c3458a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__ = __webpack_require__(945);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c3458a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Visits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_visits_Filters_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Visitas',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_visits_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'visits',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [{
        text: 'Rotina Activa',
        value: 'routine_code'
      }, {
        text: 'Vendedor RA',
        value: 'salesteam_id'
      }, {
        text: 'LE',
        value: 'client_id'
      }],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('visits/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#visits-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('visits/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'visits.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'visits.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'visits.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    },
    totalFilters: function totalFilters() {
      var total = 0;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length;
        total += this.readOptions.filters[i].excludes.length;
      }
      return total;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2018,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'visits/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d734d390_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(944);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d734d390_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Filters_RoutineFilter_vue__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Filters_ClientFilter_vue__ = __webpack_require__(442);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  components: {
    GeneralFilter: __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__["a" /* default */],
    Routine: __WEBPACK_IMPORTED_MODULE_1__views_Filters_RoutineFilter_vue__["a" /* default */],
    Client: __WEBPACK_IMPORTED_MODULE_2__views_Filters_ClientFilter_vue__["a" /* default */]
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data: function data() {
    return {
      type: null,
      name: ''
    };
  },

  methods: {
    changedFilter: function changedFilter(field, name) {
      this.type = field;
      this.name = name;
    },
    addFilter: function addFilter(evt) {
      var start = window.performance.now();
      console.log('event received', start);
      var found = false;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          });
          found = true;
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          });
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          });
        }
      }
      console.log('added to list', window.performance.now());
      console.log('added to list elapsed', window.performance.now() - start);
    },
    removeFilter: function removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1);
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1);
          }
        }
      }
    },
    removeAllFilters: function removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = [];
          this.readOptions.filters[i].excludes = [];
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Filtros"}},[_c('div',{staticClass:"row filter-column"},[_c('div',{staticClass:"col-md",class:{ 'col-md-4': _vm.showFilterGrid }},[_c('b-card-group',{attrs:{"columns":""}},[(_vm.totalFilters===0)?_c('b-card',[_vm._v("\n          Sem filtros\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.readOptions.filters),function(filter){return _c('b-card',{directives:[{name:"show",rawName:"v-show",value:(filter.includes.length > 0 || filter.excludes.length > 0),expression:"filter.includes.length > 0 || filter.excludes.length > 0"}],key:filter.field,attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            "+_vm._s(filter.title)+"\n          ")]),_vm._v(" "),_c('b-list-group',[_vm._l((filter.includes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'includes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),_vm._v(" "),_vm._l((filter.excludes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'excludes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)})],2),_vm._v(" "),_c('b-card-footer',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"text-danger",on:{"click":function($event){return _vm.removeAllFilters(filter.field)}}},[_vm._v("Limpar filtros "),_c('i',{staticClass:"fa fa-ban"})])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"col-md-8"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.filters),function(filter){return _c('b-nav-item',{key:filter.value,attrs:{"active":_vm.type === filter.value},on:{"click":function($event){return _vm.changedFilter(filter.value, filter.name)}}},[_vm._v(_vm._s(filter.text))])}),1)],1),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'salesteam_id'),expression:"type === 'salesteam_id'"}],attrs:{"ref-name":"VisitsSalesteam","url":"team","name":"Vendedores","field":"salesteam_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Routine',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'routine_code'),expression:"type === 'routine_code'"}],attrs:{"ref-name":"VisitsRoutine","url":"routines","name":"Rotina","field":"routine_code"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('Client',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'client_id'),expression:"type === 'client_id'"}],on:{"added-filter":_vm.addFilter}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"Visitas"}},[(!_vm.showResults)?_c('div',[_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.start.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "year", $$v)},expression:"readOptions.dates.start.year"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.end.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "year", $$v)},expression:"readOptions.dates.end.year"}})],1)])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"visits-results",attrs:{"id":"visits-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'visits.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"visitsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"visitsGrid","url":_vm.url,"detail-url":"visits","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('filters',{ref:"filtersPane",attrs:{"id":"filters-grid","filters":_vm.filterOptions,"showFilterGrid":_vm.showFilterGrid,"showResults":_vm.showResults,"totalFilters":_vm.totalFilters,"readOptions":_vm.readOptions}}),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipment_vue__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a84d0e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Equipment_vue__ = __webpack_require__(948);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a84d0e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Equipment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Statistics',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'equipment',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        rows: 'client_id',
        presetdate: 'all',
        datetype: 'y',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('equipment/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#equipment-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('equipment/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'equipment.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'equipment.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'equipment.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    }
  },
  created: function created() {
    var _this6 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'equipment/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this6.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"Equipamento (inventário)"}},[(!_vm.showResults)?_c('div',[(false)?_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.start.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "year", $$v)},expression:"readOptions.dates.start.year"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.end.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "year", $$v)},expression:"readOptions.dates.end.year"}})],1)])],1)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"equipment-results",attrs:{"id":"equipment-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'cabinets.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"equipmentGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"equipmentGrid","url":_vm.url,"detail-url":"equipment","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sra_vue__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284edd61_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sra_vue__ = __webpack_require__(951);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284edd61_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sra_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Visitas',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'sra',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        rows: 'client_id',
        presetdate: 'all',
        datetype: 'y',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('sra/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#sra-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('sra/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'sra.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'sra.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'sra.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2018,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'sra/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"SRA"}},[(!_vm.showResults)?_c('div',[_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.start.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "year", $$v)},expression:"readOptions.dates.start.year"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.end.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "year", $$v)},expression:"readOptions.dates.end.year"}})],1)])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"sra-results",attrs:{"id":"sra-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'sra.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"sraGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"sraGrid","url":_vm.url,"detail-url":"sra","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0d74db_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__ = __webpack_require__(954);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0d74db_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Visitas',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'promotions',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        rows: 'client_id',
        presetdate: 'all',
        datetype: 'y',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('promotions/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#promotions-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('promotions/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'promotions.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'promotions.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'promotions.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2018,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'promotions/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"Promoções"}},[(!_vm.showResults)?_c('div',[_c('b-row',[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.start.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "year", $$v)},expression:"readOptions.dates.start.year"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}}),_vm._v(" /\n                    "),_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.dates.end.year),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "year", $$v)},expression:"readOptions.dates.end.year"}})],1)])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"promotions-results",attrs:{"id":"promotions-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'promotions.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"promotionsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"promotionsGrid","url":_vm.url,"detail-url":"promotions","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stocks_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c97a88a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Stocks_vue__ = __webpack_require__(960);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stocks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c97a88a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Stocks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_stocks_Filters_vue__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Stocks',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_stocks_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'stocks',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        columns: 'gsv',
        rows: 'mpg_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2026,
        dates: {
          start: {
            day: 1,
            month: 1,
            year: 2026
          },
          end: {
            day: 31,
            month: 12,
            year: 2026
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [{
        text: 'Gama',
        value: 'mpg_id'
      }, {
        text: 'Prodaggreg',
        value: 'product_aggregator_id'
      }],
      datesOptions: [{
        text: 'todos',
        value: 'all'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: '30 dias',
        value: '30'
      }, {
        text: '60 dias',
        value: '60'
      }, {
        text: '90 dias',
        value: '90'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    }
  },
  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('stocks/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#stocks-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.details = this.rows[this.readOptions.rows].details;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('stocks/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'stocks.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'stocks.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      this.$router.push({
        name: 'stocks.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.rows = data.rows;
      this.readOptions.subrows = data.subrows;
      this.readOptions.groupby = data.groupby;
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    rowsText: function rowsText() {
      return this.rows[this.readOptions.rows].text;
    },
    totalFilters: function totalFilters() {
      var total = 0;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length;
        total += this.readOptions.filters[i].excludes.length;
      }
      return total;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this6 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this6.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'client_id',
        groupby: 'none',
        presetdate: 'all',
        datetype: 'y',
        clientType: 'A',
        docType: 'AGR',
        year: 2018,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this7 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var apiPreloads = [{
      url: 'stocks/rows',
      callback: setRows
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this7.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setRows(response) {
      that.rows = response;
      that.details = that.rows[that.readOptions.rows].details;
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc46e4d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc46e4d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Filters_ProdAgregFilter_vue__ = __webpack_require__(441);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Filters',
  components: {
    GeneralFilter: __WEBPACK_IMPORTED_MODULE_0__views_Filters_Filter_vue__["a" /* default */],
    ProdAgreg: __WEBPACK_IMPORTED_MODULE_1__views_Filters_ProdAgregFilter_vue__["a" /* default */]
  },
  props: ['showFilterGrid', 'filters', 'showResults', 'totalFilters', 'readOptions'],
  data: function data() {
    return {
      type: null,
      name: ''
    };
  },

  methods: {
    changedFilter: function changedFilter(field, name) {
      this.type = field;
      this.name = name;
    },
    addFilter: function addFilter(evt) {
      var start = window.performance.now();
      console.log('event received', start);
      var found = false;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === evt.field) {
          this.readOptions.filters[i][evt.type].push({
            id: evt.item.id,
            name: evt.item.name
          });
          found = true;
        }
      }
      if (!found) {
        if (evt.type === 'includes') {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            includes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            excludes: []
          });
        } else {
          this.readOptions.filters.push({
            field: evt.field,
            title: evt.title,
            excludes: [{
              id: evt.item.id,
              name: evt.item.name
            }],
            includes: []
          });
        }
      }
      console.log('added to list', window.performance.now());
      console.log('added to list elapsed', window.performance.now() - start);
    },
    removeFilter: function removeFilter(field, index, type) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          if (type === 'includes') {
            this.readOptions.filters[i].includes.splice(index, 1);
          } else {
            this.readOptions.filters[i].excludes.splice(index, 1);
          }
        }
      }
    },
    removeAllFilters: function removeAllFilters(field) {
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        if (this.readOptions.filters[i].field === field) {
          this.readOptions.filters[i].includes = [];
          this.readOptions.filters[i].excludes = [];
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Filtros"}},[_c('div',{staticClass:"row filter-column"},[_c('div',{staticClass:"col-md",class:{ 'col-md-4': _vm.showFilterGrid }},[_c('b-card-group',{attrs:{"columns":""}},[(_vm.totalFilters===0)?_c('b-card',[_vm._v("\n          Sem filtros\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.readOptions.filters),function(filter){return _c('b-card',{directives:[{name:"show",rawName:"v-show",value:(filter.includes.length > 0 || filter.excludes.length > 0),expression:"filter.includes.length > 0 || filter.excludes.length > 0"}],key:filter.field,attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            "+_vm._s(filter.title)+"\n          ")]),_vm._v(" "),_c('b-list-group',[_vm._l((filter.includes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'includes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),_vm._v(" "),_vm._l((filter.excludes),function(item,index){return _c('b-list-group-item',{key:item.id,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(item.name)+"\n              "),_c('b-badge',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeFilter(filter.field, index, 'excludes')}}},[_c('i',{staticClass:"fa fa-times"})])],1)})],2),_vm._v(" "),_c('b-card-footer',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"text-danger",on:{"click":function($event){return _vm.removeAllFilters(filter.field)}}},[_vm._v("Limpar filtros "),_c('i',{staticClass:"fa fa-ban"})])])],1)})],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilterGrid),expression:"showFilterGrid"}],staticClass:"col-md-8"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.filters),function(filter){return _c('b-nav-item',{key:filter.value,attrs:{"active":_vm.type === filter.value},on:{"click":function($event){return _vm.changedFilter(filter.value, filter.name)}}},[_vm._v(_vm._s(filter.text))])}),1)],1),_vm._v(" "),_c('GeneralFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'mpg_id'),expression:"type === 'mpg_id'"}],attrs:{"ref-name":"StocksMPG","url":"mpgs","name":"MPG","field":"mpg_id"},on:{"added-filter":_vm.addFilter}}),_vm._v(" "),_c('ProdAgreg',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'product_aggregator_id'),expression:"type === 'product_aggregator_id'"}],on:{"added-filter":_vm.addFilter}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1",attrs:{"header":"Stocks"}},[(!_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_vm._v("\n            a mostrar em linhas: "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"stocks-results",attrs:{"id":"stocks-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'stocks.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),(_vm.loaded)?_c('generic-grid',{ref:"stocksGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"stocksGrid","url":_vm.url,"detail-url":"stocks","columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('filters',{ref:"filtersPane",attrs:{"id":"filters-grid","filters":_vm.filterOptions,"showFilterGrid":_vm.showFilterGrid,"showResults":_vm.showResults,"totalFilters":_vm.totalFilters,"readOptions":_vm.readOptions}}),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707ae2aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(963);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707ae2aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"}},[_vm._v("Search")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8032_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(966);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8032_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for is temporarily unavailable.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-info",attrs:{"type":"button"}},[_vm._v("Search")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b8980a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(969);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b8980a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      appName: 'DIM',
      working: false,
      username: '',
      password: ''
    };
  },

  methods: {
    doLogin: function doLogin(event) {
      this.working = true;
      event.preventDefault();
      var redirect = this.$auth.redirect();
      var redirectTo = { name: 'dashboard' };
      if (redirect) {
        redirectTo = redirect.from;
      }
      this.$auth.login({
        data: {
          username: this.username,
          password: this.password
        },
        redirect: redirectTo,
        success: function success(response) {
          this.$toastr('success', 'Login efetuado com sucess');
        },
        error: function error(response) {
          this.working = false;
          console.log(response);
          this.$toastr('error', 'Nome de utilizador ou palavra-passe incorrectos');
        }
      });
    }
  },
  created: function created() {
    if (typeof Window.appConfig !== 'undefined' && Window.appConfig.name) {
      this.appName = Window.appConfig.name;
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('form',{attrs:{"action":"#"},on:{"submit":_vm.doLogin}},[_c('h3',[_vm._v(_vm._s(_vm.appName))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Bem vindo ao "+_vm._s(_vm.appName)+", para aceder à sua conta utilize o formulário abaixo.")]),_vm._v(" "),_c('b-form-group',[_c('b-input-group',[_c('b-input-group-text',{attrs:{"slot":"prepend"},slot:"prepend"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('b-form-input',{attrs:{"name":"username","placeholder":"Nome de utilizador"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1),_vm._v(" "),_c('b-form-group',[_c('b-input-group',[_c('b-input-group-text',{attrs:{"slot":"prepend"},slot:"prepend"},[_c('i',{staticClass:"fa fa-key"})]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","placeholder":"Palavra-passe"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":{name: 'forgot-password'}}},[_vm._v("Esqueceu-se da palavra-passe?")])],1),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn  btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Login")])])])],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef0cad2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__ = __webpack_require__(972);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ef0cad2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      working: false,
      email: '',
      emailSent: false,
      showForm: true
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      this.working = true;
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit();
          return;
        }
        _this.working = false;
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.axios.post('auth/sendreset', { email: this.email }).then(function (response) {
        _this2.emailSent = true;
        _this2.showForm = false;
      }).catch(function (response) {
        _this2.$toastr('error', 'Não foi possível enviar email de recuperação', 'Erro');
        _this2.working = false;
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[(_vm.showForm)?_c('form',{attrs:{"action":"#"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('h3',[_vm._v("Recuperar a palavra-passe?")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Introduza o seu email para lhe enviar-mos um email para repor a palavra-passe")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true }),expression:"{ required: true, email:true }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('email'))+"\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("Voltar ao login")])],1),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Seguinte")])])])]):_vm._e(),_vm._v(" "),(!_vm.showForm)?_c('div',[_c('h2',[_vm._v("Recuperar a palavra-passe?")]),_vm._v(" "),(_vm.emailSent)?_c('p',[_vm._v("Foi-lhe enviado um email para recuperar a palavra-passe"),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v("Voltar ao login")])],1):_vm._e(),_vm._v(" "),(!_vm.emailSent)?_c('p',[_vm._v("Este email não está registado")]):_vm._e()]):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc57aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19cc57aa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  data: function data() {
    return {
      resetSuccess: false,
      working: false,
      item: {
        password: '',
        password_confirmation: '',
        token: '',
        email: ''
      }
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return this.item.password.length > 0 && !this.errors.has('password');
    }
  },
  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit();
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    submit: function submit() {
      var _this2 = this;

      var data = this.item;
      this.axios.post('auth/reset', data).then(function (response) {
        _this2.resetSuccess = true;
      }).catch(function (response) {
        _this2.$toastr('error', response.data.message, 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  },
  created: function created() {
    if (typeof this.$route.params.token === 'undefined' || !this.$route.params.token) {
      this.$router.push({ name: 'login' });
    }
    this.item.token = this.$route.params.token;
  }
});

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-group mb-0"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[(!_vm.resetSuccess)?_c('form',{attrs:{"action":"#"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('h3',[_vm._v("Nova palavra-passe")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Para completar o processo, preencha o formulário abaixo")]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true }),expression:"{ required: true, email:true }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email')},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('email'))+"\n                  ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({required:true, min: 8}),expression:"{required:true, min: 8}"}],ref:"password",attrs:{"type":"password","name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password'),"data-vv-validate-on":"change"},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('password'))+"\n                  ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.passwordRequired}),expression:"{confirmed: 'password', required:passwordRequired}"}],attrs:{"type":"password","name":"password_confirmation","placeholder":"Confirme a palavra-passe","state":_vm.validateState('password_confirmation'),"data-vv-validate-on":"change"},model:{value:(_vm.item.password_confirmation),callback:function ($$v) {_vm.$set(_vm.item, "password_confirmation", $$v)},expression:"item.password_confirmation"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                    "+_vm._s(_vm.errors.first('password_confirmation'))+"\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-right"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"disabled":_vm.working,"type":"submit"}},[_vm._v("Alterar palavra-passe")])])])],1):_vm._e(),_vm._v(" "),(_vm.resetSuccess)?_c('div',[_c('h3',[_vm._v("Nova palavra-passe")]),_vm._v(" "),_c('p',[_vm._v("A sua palavra-passe foi alterada com sucesso.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary","to":{name:'login'}}},[_vm._v("Continuar")])],1):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_tables_missingskus__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_tables_missingcodles__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_tables_products__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_tables_clients__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_tables_sales__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_tables_imports__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_tables_imports_results__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_tables_import_result_view__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_settings_SettingsEdit__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__ = __webpack_require__(1006);











/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/tables',
  redirect: '/tables/missing-skus',
  name: 'tables',
  meta: {
    auth: true,
    label: 'Tabelas'
  },
  component: {
    render: function render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: 'missing-skus',
    name: 'tables.missing-skus',
    component: __WEBPACK_IMPORTED_MODULE_0__views_tables_missingskus__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'missing-codles',
    name: 'tables.missing-codles',
    component: __WEBPACK_IMPORTED_MODULE_1__views_tables_missingcodles__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'settings',
    name: 'tables.settings',
    component: __WEBPACK_IMPORTED_MODULE_8__views_settings_SettingsEdit__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches',
    name: 'tables.import-batches',
    component: __WEBPACK_IMPORTED_MODULE_5__views_tables_imports__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches/results/:id',
    name: 'tables.import-results',
    component: __WEBPACK_IMPORTED_MODULE_6__views_tables_imports_results__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'import-batches/results/:id/:detailId',
    name: 'tables.import-results-view',
    component: __WEBPACK_IMPORTED_MODULE_7__views_tables_import_result_view__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'mpg',
    name: 'tables.mpg',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/mpg',
      name: 'Gamas',
      tablename: 'Mpg'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'brands',
    name: 'tables.brands',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/brands',
      name: 'Marcas',
      tablename: 'Brands'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'prodaggregs',
    name: 'tables.prodaggregs',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/prodaggregs',
      name: 'ProdAgregs',
      tablename: 'Prodagreggs'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'cores',
    name: 'tables.cores',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/cores',
      name: 'Core',
      tablename: 'Core'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'products',
    name: 'tables.products',
    component: __WEBPACK_IMPORTED_MODULE_2__views_tables_products__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'clients',
    name: 'tables.clients',
    component: __WEBPACK_IMPORTED_MODULE_3__views_tables_clients__["a" /* default */],
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'activities',
    name: 'tables.activities',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/activities',
      name: 'Tipos de Actividade',
      tablename: 'activityTypes'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'operatorgroups',
    name: 'tables.operatorgroups',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/operatorgroups',
      name: 'Grupos de Operadores',
      tablename: 'operatorgroups'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'visibilities',
    name: 'tables.visibilities',
    component: __WEBPACK_IMPORTED_MODULE_9__views_tables_grid__["a" /* default */],
    props: {
      url: 'tables/visibilities',
      name: 'Visibilidades',
      tablename: 'visibilities'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'sales',
    name: 'tables.sales',
    component: __WEBPACK_IMPORTED_MODULE_4__views_tables_sales__["a" /* default */],
    props: {
      url: 'tables/sales',
      name: 'Visibilidades',
      tablename: 'sales'
    },
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
});

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_missingskus_vue__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b05d56d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_missingskus_vue__ = __webpack_require__(981);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_missingskus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b05d56d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_missingskus_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__ = __webpack_require__(447);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mpg',
  components: {
    GridLocal: __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: 'missing/sku',
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      columns: [{
        field: 'sku',
        title: 'SKU'
      }]
    };
  }
});

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name', 'schemaModelFields', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'height', 'aggregate'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_3__progress_kendo_datasource_vue_wrapper__["KendoDataSource"]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          beforeSend: function beforeSend(req) {
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    getTotal: function getTotal(response) {
      return response.data.length;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    var that = this;
    if (localStorage[this.name + 'options']) {
      this.options = JSON.parse(localStorage[this.name + 'options']);
    }
    console.log(this.options);

    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var grid = this.$refs.mygrid.kendoWidget();
    localStorage[this.name + 'options'] = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.stringify(grid.getOptions());
  }
});

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"aggregate":_vm.aggregate,"transport":_vm.gridTransport,"schema-model-fields":_vm.schemaModelFields,"schema-total":_vm.schemaTotal,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"page-size":10,"page":_vm.options.dataSource.page,"filter":_vm.options.dataSource.filter,"sort":_vm.options.dataSource.sort}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"height":_vm.height,"data-source-ref":'datasource1',"pageable":_vm.pageable,"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"header":"SKUs em falta"}},[_c('grid-local',{attrs:{"name":'missingSkuGrid',"url":_vm.url,"columns":_vm.columns,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_missingcodles_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a99e342_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_missingcodles_vue__ = __webpack_require__(984);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_missingcodles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a99e342_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_missingcodles_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__ = __webpack_require__(447);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mpg',
  components: {
    GridLocal: __WEBPACK_IMPORTED_MODULE_0__components_GridLocal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      url: 'missing/codles',
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      columns: [{
        field: 'codle',
        title: 'Codle'
      }]
    };
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"header":"Codles em falta"}},[_c('grid-local',{attrs:{"name":'missingCodleGrid',"url":_vm.url,"columns":_vm.columns,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8092cacc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__ = __webpack_require__(987);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8092cacc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Products',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [{
        field: 'product_aggregator_id',
        api: 'prodagregs/lst'
      }, {
        field: 'mpg_id',
        api: 'mpgs/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'core_id',
        api: 'cores/lst'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'product_aggregator_id': {
          type: 'number'
        },
        'mpg_id': {
          type: 'number'
        },
        'brand_id': {
          type: 'number'
        },
        'core_id': {
          type: 'number'
        }
      },
      url: 'tables/products',
      columns: [{
        width: '160px',
        field: 'sku',
        title: 'SKU'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'product_aggregator_id',
        title: 'ProdAgreg',
        width: '200px',
        values: []
      }, {
        field: 'mpg_id',
        title: 'Gama',
        width: '200px',
        values: []
      }, {
        field: 'brand_id',
        title: 'Marca',
        width: '200px',
        values: []
      }, {
        field: 'core_id',
        title: 'Core',
        width: '200px',
        values: []
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  }
});

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Produtos"}},[_c('Grid',{ref:"filterGridProducts",attrs:{"name":"filterGridProducts","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clients_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241e0042_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_clients_vue__ = __webpack_require__(990);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241e0042_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_clients_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Products',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [{
        field: 'activity_type_id',
        api: 'activities/lst'
      }, {
        field: 'visibility_id',
        api: 'visibilities/lst'
      }, {
        field: 'operator_group_id',
        api: 'operatorgroups/lst'
      }, {
        field: 'district_id',
        api: 'districts/lst'
      }, {
        field: 'county_id',
        api: 'counties/lst'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'visibility_id': {
          type: 'number'
        },
        'activity_type_id': {
          type: 'number'
        },
        'operator_group_id': {
          type: 'number'
        },
        'county_id': {
          type: 'number'
        },
        'district_id': {
          type: 'number'
        }
      },
      url: 'tables/clients',
      columns: [{
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'nif',
        title: 'NIF'
      }, {
        width: '160px',
        field: 'name',
        title: 'Nome'
      }, {
        field: 'commercial_designation',
        title: 'Designação Comercial',
        width: '200px'
      }, {
        field: 'activity_type_id',
        title: 'Tp Actividade',
        width: '200px',
        values: []
      }, {
        field: 'operator_group_id',
        title: 'Grupo Operadores',
        width: '200px',
        values: []
      }, {
        field: 'visibility_id',
        title: 'Visibilidade',
        width: '200px',
        values: []
      }, {
        field: 'county_id',
        title: 'Concelho',
        width: '200px',
        values: []
      }, {
        field: 'district_id',
        title: 'Distrito',
        width: '200px',
        values: []
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  }
});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Operadores"}},[_c('Grid',{ref:"filterGridProducts",attrs:{"name":"filterGridProducts","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sales_vue__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_426621c6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_sales_vue__ = __webpack_require__(993);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_426621c6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_sales_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Products',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'date_sold': {
          type: 'date'
        },
        'quantity': {
          type: 'number'
        },
        'gsv': {
          type: 'number'
        },
        'niv': {
          type: 'number'
        },
        'liters': {
          type: 'number'
        }
      },
      url: 'tables/sales',
      columns: [{
        field: 'date_sold',
        title: 'Data',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy'
            });
          }
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'sku',
        title: 'SKU'
      }, {
        width: '160px',
        field: 'quantity',
        title: 'Quantidade'
      }, {
        width: '160px',
        field: 'liters',
        title: 'Litros'
      }, {
        width: '160px',
        field: 'gsv',
        title: 'GSV'
      }, {
        width: '160px',
        field: 'niv',
        title: 'NIV'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  }
});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Vendas"}},[_c('Grid',{ref:"filterGridProducts",attrs:{"name":"filterGridProducts","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imports_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3f14eb0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imports_vue__ = __webpack_require__(996);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3f14eb0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imports_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(80);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Imports',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'file_rows': {
          type: 'number'
        },
        'imported_rows': {
          type: 'number'
        }
      },
      url: 'import/batches',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        width: '160px',
        field: 'id',
        title: 'ID Importação'
      }, {
        field: 'files_count',
        title: 'Nº Tabelas',
        width: '200px'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'tables.import-results',
        params: {
          id: item.id
        }
      });
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-search"></i> ver</a>';
    }
  }
});

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Importações"}},[_c('Grid',{ref:"filterGridImports",attrs:{"name":"filterGridImports","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imports_results_vue__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d61042_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imports_results_vue__ = __webpack_require__(999);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imports_results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d61042_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imports_results_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(80);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Imports',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'updated_at': {
          type: 'date'
        },
        'file_rows': {
          type: 'number'
        },
        'imported_rows': {
          type: 'number'
        }
      },
      url: 'import/results/',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        width: '160px',
        field: 'import_id',
        title: 'ID Importação'
      }, {
        field: 'tablename',
        title: 'Tabela',
        width: '200px'
      }, {
        field: 'file_rows',
        title: 'Linhas Ficheiro',
        width: '200px'
      }, {
        field: 'rows_imported',
        title: 'Linhas Importadas',
        width: '200px'
      }, {
        field: 'hasErrors',
        title: 'Erros',
        width: '200px',
        values: [{
          value: 1,
          text: 'Sim'
        }, {
          value: 0,
          text: 'Não'
        }]
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'tables.import-results-view',
        params: {
          id: this.$route.params.id,
          detailId: item.id
        }
      });
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-search"></i> ver</a>';
    }
  },
  created: function created() {
    this.url = this.url + this.$route.params.id;
  }
});

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":"Importações"}},[_c('Grid',{ref:"filterGridImportsResults",attrs:{"name":"filterGridImportsResults","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_import_result_view_vue__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a0e723_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_import_result_view_vue__ = __webpack_require__(1002);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_import_result_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a0e723_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_import_result_view_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImportDetailView',
  data: function data() {
    return {
      item: {}
    };
  },
  created: function created() {
    var _this = this;

    var detailId = this.$route.params.detailId;
    this.axios.get('import/results/details/' + detailId).then(function (response) {
      _this.item = response.data.data;
    }).catch(function (response) {
      _this.$toastr('error', 'erro ao carregar resultados da importação', 'Erro');
    });
  }
});

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-card',{attrs:{"header":"detalhes"}},[_c('dl',[_c('dt',[_vm._v("Tabela:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.item.tablename))]),_vm._v(" "),_c('dt',[_vm._v("Linhas do ficheiro:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.item.file_rows))]),_vm._v(" "),_c('dt',[_vm._v("Linhas importadas:")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.item.rows_imported))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-card',{attrs:{"header":"erros"}},[_c('div',{staticClass:"errorsReport"},[_vm._v(_vm._s(_vm.item.errors))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsEdit_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_895900b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsEdit_vue__ = __webpack_require__(1005);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_895900b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SettingsEdit',
  props: ['id'],
  data: function data() {
    return {
      item: {
        open: 0,
        expired: 0
      },
      roles: []
    };
  },

  methods: {
    submit: function submit(e, close) {
      var _this = this;

      e.preventDefault();
      var data = {
        data: this.item
      };
      this.axios.put('settings', data).then(function (response) {
        _this.item = response.data.data;
        _this.$toastr('success', 'item gravado com sucesso', 'Gravado');
      }).catch(function (response) {
        _this.$toastr('error', 'Não foi possivel gravar', 'Erro');
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.axios.get('settings').then(function (response) {
      _this2.item = response.data.data;
    }).catch(function (response) {
      _this2.$toastr('error', 'Erro ao carregar definições', 'Erro');
      _this2.$router.push({
        name: 'settings.index'
      });
    });
  }
});

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){return _vm.submit($event,false)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Item")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Valor Aberto"}},[_c('b-form-input',{attrs:{"type":"text","name":"open","placeholder":"Valor Aberto"},model:{value:(_vm.item.open),callback:function ($$v) {_vm.$set(_vm.item, "open", $$v)},expression:"item.open"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Valor Expirado"}},[_c('b-form-input',{attrs:{"type":"text","name":"expired","placeholder":"Valor Aberto"},model:{value:(_vm.item.expired),callback:function ($$v) {_vm.$set(_vm.item, "expired", $$v)},expression:"item.expired"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'users.index'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")])],1)])])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f00927c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__ = __webpack_require__(1008);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f00927c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mpg',
  props: ['url', 'name', 'tablename'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      loaded: false,
      schemaModelFields: {},
      columns: [{
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.loaded = false;
      var that = this;
      setTimeout(function () {
        that.loaded = true;
      }, 10);
    }
  },
  created: function created() {
    this.loaded = true;
  }
});

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"header":_vm.name}},[(_vm.loaded)?_c('Grid',{ref:'filterGrid'+_vm.tablename,attrs:{"name":'filterGrid'+_vm.tablename,"url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersGrid_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5a5253_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersGrid_vue__ = __webpack_require__(1011);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5a5253_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_all_js__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'admin/users',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px'
      }, {
        command: {
          text: 'Apagar',
          click: this.deleteUser
        },
        width: '80px'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '220px'
      }, {
        field: 'state',
        title: 'Estado',
        width: '120px',
        values: [{
          text: 'Activo',
          value: 1
        }, {
          text: 'Bloqueado',
          value: 0
        }]
      }, {
        field: 'email',
        title: 'Email',
        width: '220px'
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    deleteUser: function deleteUser(e) {
      e.preventDefault();
      var grid = this.$refs.usersGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.showDeleteUserConfirm(dataItem);
    },
    showDeleteUserConfirm: function showDeleteUserConfirm(item) {
      var _this = this;

      this.boxTwo = '';
      this.$bvModal.msgBoxConfirm('Quer mesmo apagar este utilizador?', {
        title: 'Apagar utilizador?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(function (value) {
        if (value) {
          _this.axios.delete('admin/users/' + item.id).then(function (response) {
            var grid = _this.$refs.usersGrid.$refs.mygrid.kendoWidget();
            grid.dataSource.read();
          });
        }
      }).catch(function (err) {
        console.error(err);
      });
    },

    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'users.edit',
        params: {
          id: item.id
        }
      });
      if (this.$auth.check('roles.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-edit"></i> editar</a>';
      }
      return '';
    }
  }
});

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"text-right mb-3"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name:'users.create'}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Criar")])],1),_vm._v(" "),_c('Grid',{ref:"usersGrid",attrs:{"name":"usersGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersEdit_vue__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3b99d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersEdit_vue__ = __webpack_require__(1017);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac3b99d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UsersEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamMembers_vue__ = __webpack_require__(1014);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersEdit',
  props: ['id'],
  components: { TeamMembers: __WEBPACK_IMPORTED_MODULE_0__TeamMembers_vue__["a" /* default */] },
  data: function data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        password: '',
        password_confirmation: '',
        state: 1,
        sendEmail: null,
        roles: [],
        salesteam: { data: [] }
      },
      roles: [],
      passwordSize: 12,
      characters: 'a-z,A-Z,0-9,#'
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return !this.item.id;
    },
    confirmPasswordRequired: function confirmPasswordRequired() {
      return this.item.password.length > 0;
    }
  },
  methods: {
    selectTeamMembers: function selectTeamMembers(e) {
      this.item.salesteam.data.push({ id: e.item.id, name: e.item.name });
    },
    showTeamModal: function showTeamModal() {
      this.$refs.teamMembersModal.show();
    },
    hideTeamModal: function hideTeamModal() {
      this.$refs.teamMembersModal.hide();
    },
    removeTeamMember: function removeTeamMember(index) {
      this.item.salesteam.data.splice(index, 1);
    },
    toggleViewPassword: function toggleViewPassword() {
      this.showPassword = !this.showPassword;
    },
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit(evt, close);
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit: function submit(e, close) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        data: this.item
      };
      if (this.item.id) {
        this.axios.put('admin/users' + '/' + this.item.id, data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          if (close) {
            _this2.$router.push({
              name: 'users.index'
            });
          }
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      } else {
        this.axios.post('admin/users', data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          _this2.$router.push({
            name: 'users.edit',
            params: {
              id: _this2.item.id
            }
          });
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      }
    },
    generate: function generate() {
      var charactersArray = this.characters.split(',');
      var CharacterSet = '';
      var password = '';

      if (charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
      }
      if (charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      if (charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '0123456789';
      }
      if (charactersArray.indexOf('#') >= 0) {
        CharacterSet += '![]{}()%&*$#^<>~@|';
      }

      for (var i = 0; i < this.passwordSize; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
      }
      this.item.password = password;
      this.item.password_confirmation = password;
      this.showPassword = true;
    }
  },
  created: function created() {
    var _this3 = this;

    var id = this.$route.params.id;
    if (typeof id !== 'undefined') {
      this.axios.get('admin/users' + '/' + id).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (response) {
        _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
        _this3.$router.push({
          name: 'users.index'
        });
      });
    } else {
      this.item.sendEmail = 1;
    }
    this.axios.get('admin/roles/lst').then(function (response) {
      _this3.roles = response.data.data;
    });
  }
});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembers_vue__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e1ea1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembers_vue__ = __webpack_require__(1016);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeamMembers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e1ea1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TeamMembers_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Client',
  props: ['height'],
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'team',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Adicionar',
          click: this.addTeamMember
        }
      }, {
        field: 'name',
        title: 'Name'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    };
  },

  methods: {
    addTeamMember: function addTeamMember(e) {
      e.preventDefault();
      var grid = this.$refs.userQueriesGrid.$refs.mygrid.kendoWidget();
      var dataItem = grid.dataItem(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(e.currentTarget).closest('tr'));
      this.$emit('select-member', {
        item: dataItem
      });
    }
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"userQueriesGrid",attrs:{"name":"userQueriesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-5"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Item")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Nome","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true, uniqueemail: _vm.item.id }),expression:"{ required: true, email:true, uniqueemail: item.id }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email'),"data-vv-validate-on":"change"},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('email'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome de utilizador"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ username: _vm.item.id, required: true, min:5 }),expression:"{ username: item.id, required: true, min:5 }"}],attrs:{"id":"itemName","type":"text","name":"username","placeholder":"Nome de utilizador","state":_vm.validateState('username'),"data-vv-validate-on":"change"},model:{value:(_vm.item.username),callback:function ($$v) {_vm.$set(_vm.item, "username", $$v)},expression:"item.username"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('username'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-input-group',[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 8, required:_vm.passwordRequired}),expression:"{min: 8, required:passwordRequired}"}],ref:"password",attrs:{"type":!_vm.showPassword?'password':'text',"name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password')},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{on:{"click":function($event){return _vm.toggleViewPassword()}}},[_c('i',{staticClass:"fa",class:{'fa-eye':!_vm.showPassword, 'fa-eye-slash':_vm.showPassword}})]),_vm._v(" "),_c('b-button',{attrs:{"variant":"info"},on:{"click":function($event){return _vm.generate()}}},[_vm._v("Gerar palavra-passe "+_vm._s(_vm.passwordRequired))])],1),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n                "+_vm._s(_vm.errors.first('password'))+"\n              ")])],1)],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.confirmPasswordRequired}),expression:"{confirmed: 'password', required:confirmPasswordRequired}"}],attrs:{"type":!_vm.showPassword?'password':'text',"name":"password_confirmation","state":_vm.validateState('password_confirmation'),"placeholder":"Confirme a palavra-passe"},model:{value:(_vm.item.password_confirmation),callback:function ($$v) {_vm.$set(_vm.item, "password_confirmation", $$v)},expression:"item.password_confirmation"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password_confirmation'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'users.index'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Estado")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Estado"}},[_c('b-form-select',{staticClass:"mb-3",model:{value:(_vm.item.state),callback:function ($$v) {_vm.$set(_vm.item, "state", $$v)},expression:"item.state"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Bloqueado")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Activo")])])],1),_vm._v(" "),(!_vm.item.id)?_c('b-form-fieldset',{attrs:{"label":"Enviar email de boas vindas"}},[_c('b-form-select',{staticClass:"mb-3",model:{value:(_vm.item.sendEmail),callback:function ($$v) {_vm.$set(_vm.item, "sendEmail", $$v)},expression:"item.sendEmail"}},[_c('option',{domProps:{"value":null}},[_vm._v("Escolha uma opção")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])],1):_vm._e()],1),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Grupos")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"roles","name":"roles"},model:{value:(_vm.item.roles_list),callback:function ($$v) {_vm.$set(_vm.item, "roles_list", $$v)},expression:"item.roles_list"}},_vm._l((_vm.roles),function(role){return _c('div',{key:role.id},[_c('b-form-checkbox',{attrs:{"value":role.id}},[_vm._v(_vm._s(role.name))])],1)}),0)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',[_vm._v("\n            Vendedores associados\n          ")]),_vm._v(" "),_c('b-list-group',_vm._l((_vm.item.salesteam.data),function(teamMember,index){return _c('b-list-group-item',{key:index,staticClass:"d-flex justify-content-between align-items-center",attrs:{"variant":"success"}},[_vm._v("\n              "+_vm._s(teamMember.name)+"\n              "),_c('b-badge',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.removeTeamMember(index)}}},[_c('i',{staticClass:"fa fa-times"})])],1)}),1),_vm._v(" "),_c('b-card-footer',[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.showTeamModal}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar vendedor")])],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"teamMembersModal",attrs:{"size":"lg","id":"teamMembersModal"},on:{"shown":function($event){_vm.showTeam=true},"hidden":function($event){_vm.showTeam=false}}},[(_vm.showTeam)?_c('team-members',{attrs:{"height":"400"},on:{"select-member":_vm.selectTeamMembers}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443eec4e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(1020);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_443eec4e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Profile',
  data: function data() {
    return {
      preloadDone: false,
      item: {
        name: '',
        password_confirm: '',
        password: ''
      },
      roles: []
    };
  },

  computed: {
    passwordRequired: function passwordRequired() {
      return this.item.password.length > 0;
    }
  },
  methods: {
    submit: function submit(e, close) {
      var _this = this;

      var data = {
        data: this.item
      };
      this.axios.put('users/profile', data).then(function (response) {
        _this.item = response.data.data;
        _this.$toastr('success', 'perfil atualizado com sucesso', 'Gravado');
        if (close) {
          _this.$router.push({
            name: 'dashboard'
          });
        }
      }).catch(function (response) {
        _this.$toastr('error', 'Não foi possivel gravar', 'Erro');
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this2 = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this2.submit(evt, close);
          return;
        }
        _this2.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    }
  },
  created: function created() {
    var _this3 = this;

    this.axios.get('users/profile').then(function (response) {
      _this3.item = response.data.data;
      _this3.preloadDone = true;
    }).catch(function (response) {
      _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
      _this3.$router.push({
        name: 'dashboard'
      });
    });
  }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row justify-content-md-center mt-5"},[_c('div',{staticClass:"col-md-4"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Dados de utilizador")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Nome","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, email:true, uniqueemail: _vm.item.id }),expression:"{ required: true, email:true, uniqueemail: item.id }"}],attrs:{"type":"email","name":"email","placeholder":"Email","state":_vm.validateState('email'),"data-vv-validate-on":"change"},model:{value:(_vm.item.email),callback:function ($$v) {_vm.$set(_vm.item, "email", $$v)},expression:"item.email"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('email'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome de utilizador"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({ username: _vm.item.id, required: true, min:5 }),expression:"{ username: item.id, required: true, min:5 }"}],attrs:{"id":"itemName","type":"text","name":"username","placeholder":"Nome de utilizador","state":_vm.validateState('username'),"data-vv-validate-on":"change"},model:{value:(_vm.item.username),callback:function ($$v) {_vm.$set(_vm.item, "username", $$v)},expression:"item.username"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('username'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({min: 8}),expression:"{min: 8}"}],ref:"password",attrs:{"type":"password","name":"password","placeholder":"Palavra-passe","state":_vm.validateState('password')},model:{value:(_vm.item.password),callback:function ($$v) {_vm.$set(_vm.item, "password", $$v)},expression:"item.password"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Confirme a palavra-passe"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({confirmed: 'password', required:_vm.passwordRequired}),expression:"{confirmed: 'password', required:passwordRequired}"}],attrs:{"type":"password","name":"password_confirm","placeholder":"Confirme a palavra-passe","state":_vm.validateState('password_confirm')},model:{value:(_vm.item.password_confirm),callback:function ($$v) {_vm.$set(_vm.item, "password_confirm", $$v)},expression:"item.password_confirm"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('password_confirm'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'dashboard'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1)],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce9af88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__ = __webpack_require__(1023);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce9af88_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_grid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(80);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RolesGrid',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_0__components_Grid_vue__["a" /* default */]
  },
  data: function data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      url: 'admin/roles',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'display_name',
        title: 'Nome'
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          ui: function ui(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            });
          }
        }
      }]
    };
  },

  methods: {
    getBtnTemplate: function getBtnTemplate(item) {
      var route = __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].resolve({
        name: 'roles.edit',
        params: {
          id: item.id
        }
      });
      return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>';
    }
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"text-right mb-3"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name:'roles.create'}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Criar")])],1),_vm._v(" "),_c('Grid',{attrs:{"name":"rolesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e130900_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__(1026);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e130900_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UsersEdit',
  props: ['id'],
  data: function data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        display_name: '',
        mpgs: []
      },
      permissionGroups: [],
      mpg_list: []
    };
  },

  methods: {
    validateBeforeSubmit: function validateBeforeSubmit(evt, close) {
      var _this = this;

      evt.preventDefault();
      console.log('check validation');
      this.$validator.validateAll().then(function (result) {
        console.log('validation results:', result);
        if (result) {
          console.log('all fields ok. submit');
          _this.submit(evt, close);
          return;
        }
        _this.$toastr('error', 'Tem campos inválidos', 'Erro');
      });
    },
    validateState: function validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    submit: function submit(e, close) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        data: this.item
      };
      if (this.item.id) {
        this.axios.put('admin/roles' + '/' + this.item.id, data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          if (close) {
            _this2.$router.push({
              name: 'roles.index'
            });
          }
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      } else {
        this.axios.post('admin/roles', data).then(function (response) {
          _this2.item = response.data.data;
          _this2.$toastr('success', 'item gravado com sucesso', 'Gravado');
          _this2.$router.push({
            name: 'roles.edit',
            params: {
              id: _this2.item.id
            }
          });
        }).catch(function (response) {
          _this2.$toastr('error', 'Não foi possivel gravar', 'Erro');
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    var id = this.$route.params.id;
    if (typeof id !== 'undefined') {
      this.axios.get('admin/roles' + '/' + id).then(function (response) {
        _this3.item = response.data.data;
        if (typeof _this3.item.mpgs === 'undefined') {
          _this3.item.mpgs = [];
        }
      }).catch(function (response) {
        _this3.$toastr('error', 'Este utilizador não existe', 'Erro');
        _this3.$router.push({
          name: 'roles.index'
        });
      });
    }
    this.axios.get('admin/permissions/lst').then(function (response) {
      _this3.permissionGroups = response.data.data;
    });
    this.axios.get('mpgs/lst').then(function (response) {
      _this3.mpg_list = response.data.data;
    });
  }
});

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn mt-5"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){return _vm.validateBeforeSubmit($event,false)}}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Item")])]),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Código"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"name","placeholder":"Código","state":_vm.validateState('name')},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Nome"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","name":"display_name","placeholder":"Nome","state":_vm.validateState('display_name')},model:{value:(_vm.item.display_name),callback:function ($$v) {_vm.$set(_vm.item, "display_name", $$v)},expression:"item.display_name"}}),_vm._v(" "),_c('b-form-invalid-feedback',[_vm._v("\n              "+_vm._s(_vm.errors.first('name'))+"\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('router-link',{attrs:{"to":{name:'roles.index'},"size":"sm","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Cancelar")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-right"},[_c('b-button',{attrs:{"type":"submit","size":"sm","variant":"primary"}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary"},on:{"click":function($event){return _vm.validateBeforeSubmit($event,true)}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Gravar e fechar")])],1)])])],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Grupos")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"permissions","name":"permissions"},model:{value:(_vm.item.permissions_list),callback:function ($$v) {_vm.$set(_vm.item, "permissions_list", $$v)},expression:"item.permissions_list"}},[_c('b-row',_vm._l((_vm.permissionGroups),function(pgroup){return _c('b-col',{staticClass:"mb-4",attrs:{"sm":"6","md":"4"}},[_c('h6',[_vm._v(_vm._s(pgroup.name))]),_vm._v(" "),_vm._l((pgroup.permissions.data),function(permission){return _c('div',{key:permission.id},[_c('b-form-checkbox',{attrs:{"value":permission.id}},[_vm._v(_vm._s(permission.display_name))])],1)})],2)}),1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mt-5"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Gamas")])]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"id":"mpg","name":"mpg"},model:{value:(_vm.item.mpgs),callback:function ($$v) {_vm.$set(_vm.item, "mpgs", $$v)},expression:"item.mpgs"}},_vm._l((_vm.mpg_list),function(mpg){return _c('div',{key:mpg.id},[_c('b-form-checkbox',{attrs:{"value":mpg.id}},[_vm._v(_vm._s(mpg.name))])],1)}),0)],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a45efb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__(1029);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a45efb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__progress_kendo_popups_vue_wrapper__["PopupsInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_fullscreen___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Statistics',
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__views_Statistics_Filters_vue__["a" /* default */],
    UserQueries: __WEBPACK_IMPORTED_MODULE_2__views_Statistics_UserQueries_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'statistics',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        columns: 'gsv',
        rows: 'products',
        subrows: 'product_aggregator_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        year: 2026,
        clientType: 'A',
        orderType: 'A',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      orderTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'Offline',
        text: 'Offline'
      }, {
        value: 'Online',
        text: 'Online'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }, {
        value: 'SG',
        text: 'Só guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'até ontem',
        value: 'today'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: 'Q2',
        value: 'q2'
      }, {
        text: 'Q3',
        value: 'q3'
      }, {
        text: 'Q4',
        value: 'q4'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    };
  },

  methods: {
    showData: function showData() {
      var _this = this;

      this.loaded = false;
      this.loadingResults = true;
      this.queryErrorShow = false;
      this.showFilterGrid = false;
      this.showResults = false;
      this.axios.post('statistics/columns', this.readOptions).then(function (response) {
        _this.columns = response.data.data.columns;
        _this.aggregateDefinition = response.data.data.aggregates;
        _this.groupDefinition = response.data.data.groups;
        _this.schemaModelFields = response.data.data.fields;

        if (!_this.tableInitialized) {
          _this.loaded = true;
          _this.showResults = true;
        } else {
          _this.$refs.statsGrid.refresh();
          _this.showResults = true;
          _this.loaded = true;
        }
        var that = _this;
        setTimeout(function () {
          that.$scrollTo('#statistics-results', 300, {
            offset: -60
          });
        }, 100);
      });
    },
    showForm: function showForm() {
      this.loaded = false;
      this.showResults = false;
      this.showFilterGrid = true;
      this.loadingResults = false;
    },
    loadingError: function loadingError(e) {
      this.loaded = false;
      this.loadingResults = false;
      this.showFilterGrid = true;
      this.showResults = false;
      this.queryErrorShow = true;
    },
    changedRows: function changedRows() {
      this.subrows = this.rows[this.readOptions.rows].sub;
      this.readOptions.subrows = this.rows[this.readOptions.rows].default;
      this.details = this.subrows[this.readOptions.subrows].details;
      this.setGroups();
    },
    setGroups: function setGroups() {
      this.groups = [];
      var g = this.subrows[this.readOptions.subrows].groupby;
      this.groups.push({
        value: 'none',
        text: 'Consolidado'
      });

      var active = false;
      for (var i = 0; i < g.length; i++) {
        this.groups.push(g[i]);
        if (this.readOptions.groupby === g[i].value) {
          active = true;
        }
      }
      if (!active) {
        this.readOptions.groupby = 'none';
      }
    },
    changedSubRows: function changedSubRows() {
      this.details = this.subrows[this.readOptions.subrows].details;
      this.groups = [];
      this.setGroups();
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('statistics/export', this.readOptions).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModal.show();
        _this2.exporting = false;
      });
    },
    toggleFullscreen: function toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid;
    },

    hideModal: function hideModal() {
      this.$refs.downloadModal.hide();
    },
    hideSaveModal: function hideSaveModal() {
      this.$refs.saveModal.hide();
    },
    hideShareModal: function hideShareModal() {
      this.$refs.shareModal.hide();
    },
    getTooltipContents: function getTooltipContents(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif');
    },
    getQuery: function getQuery(queryId) {
      var _this3 = this;

      this.axios.get('queries/' + queryId).then(function (response) {
        _this3.loadQuery(response.data.data);
      });
    },
    openSaveQueryPopup: function openSaveQueryPopup() {
      this.$refs.saveModal.show();
    },
    openLoadQueryPopup: function openLoadQueryPopup() {
      this.$refs.loadQueryModal.show();
    },
    shareQuery: function shareQuery() {
      var _this4 = this;

      this.axios.post('queries', this.readOptions).then(function (response) {
        var route = _this4.$router.resolve({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this4.queryUrl = window.location.origin + route.href;
        _this4.$refs.shareModal.show();
      });
    },
    saveQuery: function saveQuery() {
      var _this5 = this;

      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(function (response) {
        _this5.$router.replace({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        });
        _this5.hideSaveModal();
      });
    },
    loadUserQuery: function loadUserQuery(evt) {
      var _this6 = this;

      this.$router.push({
        name: 'statistics.index',
        params: {
          id: evt.item.uquery.data.uuid
        }
      });
      if (this.$route.params.id === evt.item.uquery.data.uuid) {
        this.axios.get('queries/' + evt.item.uquery.data.uuid).then(function (response) {
          _this6.loadQuery(response.data.data);
        });
      }

      this.$refs.loadQueryModal.hide();
    },
    loadQuery: function loadQuery(data) {
      this.readOptions.presetdate = data.presetdate;
      this.readOptions.datetype = data.datetype;
      this.readOptions.dates = data.dates;
      this.readOptions.year = data.year;
      this.readOptions.columns = data.columns;
      this.readOptions.docType = data.docType;
      this.readOptions.clientType = data.clientType;
      this.readOptions.orderType = data.orderType;
      this.readOptions.rows = data.rows;
      var that = this;
      setTimeout(function () {
        that.readOptions.subrows = data.subrows;
        that.readOptions.groupby = data.groupby;
      }, 100);
      setTimeout(function () {}, 100);
      this.readOptions.filters = data.filters;
    }
  },
  computed: {
    columnsName: function columnsName() {
      return this.variables[this.readOptions.columns].text;
    },
    datesText: function datesText() {
      var txt = 'Ano: <strong>' + this.readOptions.year + '</strong> vs <strong>' + (this.readOptions.year - 1) + '</strong> ';
      txt += 'período: <strong>';
      switch (this.readOptions.presetdate) {
        case 'today':
          txt += ' do início do ano até ontem';
          break;
        case 'q1':
          txt += ' 1º trimestre';
          break;
        case 'q2':
          txt += ' 2º trimestre';
          break;
        case 'q3':
          txt += ' 3º trimestre';
          break;
        case 'q4':
          txt += ' 4º trimestre';
          break;
        case 'custom':
          txt += ' de ' + this.readOptions.dates.start.day + '/' + this.readOptions.dates.start.month;
          txt += ' a ' + this.readOptions.dates.end.day + '/' + this.readOptions.dates.end.month;
      }
      txt += '</strong>';
      return txt;
    },
    groupByName: function groupByName() {
      var sub = this.rows[this.readOptions.rows].sub;
      var groups = sub[this.readOptions.subrows].groupby;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].value === this.readOptions.groupby) {
          return groups[i].text;
        }
      }
      return '';
    },
    rowsText: function rowsText() {
      var sub = this.rows[this.readOptions.rows].sub;
      return sub[this.readOptions.subrows].text + ' (' + this.rows[this.readOptions.rows].text + ')';
    },
    totalFilters: function totalFilters() {
      var total = 0;
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length;
        total += this.readOptions.filters[i].excludes.length;
      }
      return total;
    }
  },
  watch: {
    'readOptions.rows': function readOptionsRows(val, oldVal) {
      this.changedRows();
    },
    'readOptions.subrows': function readOptionsSubrows(val, oldVal) {
      this.changedSubRows();
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this7 = this;

    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(function (response) {
        _this7.loadQuery(response.data.data);
        next();
      });
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'products',
        subrows: 'product_aggregator_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        clientType: 'A',
        orderType: 'A',
        docType: 'AGR',
        year: 2020,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      };
      next();
    }
  },
  created: function created() {
    var _this8 = this;

    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      });
    }
    var today = new Date();
    var apiPreloads = [{
      url: 'statistics/variables',
      callback: setVariables
    }, {
      url: 'statistics/rows',
      callback: setRows
    }, {
      url: 'statistics/filters',
      callback: setFilters
    }];
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      });
    }
    var that = this;
    this.axios.all(apiPreloads.map(function (l) {
      return _this8.axios.get(l.url);
    })).then(that.axios.spread(function () {
      for (var i = 0; i < apiPreloads.length; i++) {
        apiPreloads[i].callback(arguments[i].data.data);
      }
      that.preloadDone = true;
    })).catch(function (response) {
      console.error('error loading foreigns', response);
    });

    function setVariables(response) {
      that.variables = response;
    }

    function setRows(response) {
      that.rows = response;
      that.subrows = that.rows[that.readOptions.rows].sub;
      that.readOptions.subrows = that.rows[that.readOptions.rows].default;
      that.details = that.subrows[that.readOptions.subrows].details;
      that.setGroups();
    }

    function setFilters(response) {
      that.filterOptions = response;
    }
    this.readOptions.dates.end.day = today.getDate();
    this.readOptions.dates.end.month = today.getMonth() + 1;
  }
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.preloadDone)?_c('div',{staticClass:"splash"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.preloadDone)?_c('div',[_c('b-card',{staticClass:"mt-1"},[_c('div',{staticClass:"text-right queries-toolbar"},[(!_vm.showResults)?_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openLoadQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-folder-open"})]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openSaveQueryPopup($event)}}},[_c('i',{staticClass:"fa fa-save"})]),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.shareQuery($event)}}},[_c('i',{staticClass:"fa fa-share-alt"})])]),_vm._v(" "),(!_vm.showResults)?_c('div',[_c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de comparação"}},[_c('b-form-radio-group',{attrs:{"id":"radioDates","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.periodType,"name":"radiosBtnDatesType"},model:{value:(_vm.readOptions.datetype),callback:function ($$v) {_vm.$set(_vm.readOptions, "datetype", $$v)},expression:"readOptions.datetype"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('b-form-group',{attrs:{"label":"Ano"}},[_c('b-form-select',{attrs:{"options":_vm.years},model:{value:(_vm.readOptions.year),callback:function ($$v) {_vm.$set(_vm.readOptions, "year", $$v)},expression:"readOptions.year"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Intervalo"}},[_c('b-form-radio-group',{attrs:{"id":"datesOptions","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.datesOptions,"name":"radiosBtndatesOptions"},model:{value:(_vm.readOptions.presetdate),callback:function ($$v) {_vm.$set(_vm.readOptions, "presetdate", $$v)},expression:"readOptions.presetdate"}})],1)],1),_vm._v(" "),(_vm.readOptions.presetdate==='custom')?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('b-form-group',{attrs:{"label":"De"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.start.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "day", $$v)},expression:"readOptions.dates.start.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.start.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.start, "month", $$v)},expression:"readOptions.dates.start.month"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-group',{attrs:{"label":"a"}},[_c('div',{staticClass:"form-inline"},[_c('b-form-select',{attrs:{"options":_vm.days},model:{value:(_vm.readOptions.dates.end.day),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "day", $$v)},expression:"readOptions.dates.end.day"}}),_vm._v(" /\n                      "),_c('b-form-select',{attrs:{"options":_vm.months},model:{value:(_vm.readOptions.dates.end.month),callback:function ($$v) {_vm.$set(_vm.readOptions.dates.end, "month", $$v)},expression:"readOptions.dates.end.month"}})],1)])],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',{attrs:{"label":"Variável a analisar"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios1","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.variables,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.columns),callback:function ($$v) {_vm.$set(_vm.readOptions, "columns", $$v)},expression:"readOptions.columns"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de cliente"}},[_c('b-form-radio-group',{attrs:{"id":"btnradiosclitype","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.clientTypes,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.clientType),callback:function ($$v) {_vm.$set(_vm.readOptions, "clientType", $$v)},expression:"readOptions.clientType"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de encomenda"}},[_c('b-form-radio-group',{attrs:{"id":"btnradiosclitype","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.orderTypes,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.orderType),callback:function ($$v) {_vm.$set(_vm.readOptions, "orderType", $$v)},expression:"readOptions.orderType"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('b-form-group',{attrs:{"label":"Tipo de documento"}},[_c('b-form-radio-group',{attrs:{"id":"btnradiodoctype","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.documentTypes,"name":"radiosBtnVars"},model:{value:(_vm.readOptions.docType),callback:function ($$v) {_vm.$set(_vm.readOptions, "docType", $$v)},expression:"readOptions.docType"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('b-form-group',{attrs:{"label":"Mostrar em linha"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios2","button-variant":"outline-primary","buttons":"","size":"sm","options":_vm.rows,"name":"radiosRows"},model:{value:(_vm.readOptions.rows),callback:function ($$v) {_vm.$set(_vm.readOptions, "rows", $$v)},expression:"readOptions.rows"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"9"}},[_c('div',[_c('b-form-group',{attrs:{"label":"Detalhe"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios3","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.subrows,"name":"radiosSubRows"},model:{value:(_vm.readOptions.subrows),callback:function ($$v) {_vm.$set(_vm.readOptions, "subrows", $$v)},expression:"readOptions.subrows"}})],1)],1),_vm._v(" "),_c('div',[_c('b-form-group',{attrs:{"label":"Agrupar por"}},[_c('b-form-radio-group',{attrs:{"id":"btnradios4","buttons":"","size":"sm","button-variant":"outline-primary","options":_vm.groups,"name":"radiosSubRows"},model:{value:(_vm.readOptions.groupby),callback:function ($$v) {_vm.$set(_vm.readOptions, "groupby", $$v)},expression:"readOptions.groupby"}})],1)],1)])],1),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"btn-block",attrs:{"variant":"success","disabled":_vm.loadingResults,"size":"lg"},on:{"click":function($event){return _vm.showData()}}},[_c('i',{staticClass:"fa fa-search",class:{'fa-search': !_vm.loadingResults, 'fa-spinner': _vm.loadingResults, 'fa-spin': _vm.loadingResults}}),_vm._v(" Pesquisar")])],1),_vm._v(" "),_c('b-alert',{staticClass:"mt-3",attrs:{"variant":"danger","show":_vm.queryErrorShow,"dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Erro")]),_vm._v(" Houve um erro com a sua pesquisa\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.showResults)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',[_vm._v("A analisar: "),_c('strong',[_vm._v(_vm._s(_vm.columnsName))]),_vm._v(" por "),_c('strong',[_vm._v(_vm._s(_vm.rowsText))]),_vm._v(" "),(_vm.readOptions.groupby !== 'none')?_c('span',[_vm._v(" agrupado por "),_c('strong',[_vm._v(_vm._s(_vm.groupByName))])]):_vm._e(),_vm._v(" | "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#filters-grid'),expression:"'#filters-grid'"}],attrs:{"href":"#"}},[_c('strong',[_vm._v(_vm._s(_vm.totalFilters))]),_vm._v(" filtros")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.datesText)}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-button',{staticClass:"pull-right btn-block",attrs:{"variant":"warning","size":"lg"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("Alterar")])],1)])]):_vm._e()]),_vm._v(" "),_c('fullscreen',{attrs:{"fullscreen":_vm.fullscreenGrid},on:{"update:fullscreen":function($event){_vm.fullscreenGrid=$event}}},[(_vm.showResults)?_c('div',{staticClass:"statistics-results",attrs:{"id":"statistics-results"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"text-right"},[(_vm.$auth.check(['all.export', 'dim.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e(),_vm._v(" |\n            "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleFullscreen}},[_c('i',{staticClass:"fa fa-expand"}),_vm._v(" fullscreen")])]),_vm._v(" "),_c('kendo-tooltip',{attrs:{"content":_vm.getTooltipContents,"width":200,"filter":'.value-cell'}},[(_vm.loaded)?_c('statistics-grid',{ref:"statsGrid",attrs:{"rows":_vm.rows,"groupDefinition":_vm.groupDefinition,"aggregateDefinition":_vm.aggregateDefinition,"query":_vm.readOptions,"name":"statisticsGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"schemaModelId":'id',"preload":_vm.preload,"details":_vm.details},on:{"ds-error":_vm.loadingError}}):_vm._e()],1)],1)],1):_vm._e()]),_vm._v(" "),_c('filters',{ref:"filtersPane",attrs:{"id":"filters-grid","filters":_vm.filterOptions,"showFilterGrid":_vm.showFilterGrid,"showResults":_vm.showResults,"totalFilters":_vm.totalFilters,"readOptions":_vm.readOptions}})],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"downloadModal",attrs:{"id":"downloadModal"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)]),_vm._v(" "),_c('b-modal',{ref:"saveModal",attrs:{"id":"saveModal","title":"Gravar pesquisa"}},[_c('b-form',{on:{"submit":_vm.saveQuery}},[_c('b-form-input',{ref:"queryName",attrs:{"type":"text"},model:{value:(_vm.queryName),callback:function ($$v) {_vm.queryName=$$v},expression:"queryName"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideSaveModal}},[_vm._v("\n        Close\n      ")]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"success"},on:{"click":_vm.saveQuery}},[_c('i',{staticClass:"fa fa-save-o"}),_vm._v(" Gravar\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"shareModal",attrs:{"id":"shareModal"}},[_c('b-form',[_c('b-form-input',{ref:"queryName",attrs:{"readonly":"","type":"text"},model:{value:(_vm.queryUrl),callback:function ($$v) {_vm.queryUrl=$$v},expression:"queryUrl"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":_vm.hideShareModal}},[_vm._v("\n        Close\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"loadQueryModal",attrs:{"size":"lg","id":"loadQueryModal"},on:{"shown":function($event){_vm.showQueries=true},"hidden":function($event){_vm.showQueries=false}}},[(_vm.showQueries)?_c('UserQueries',{attrs:{"height":"400"},on:{"load-query":_vm.loadUserQuery}}):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 456,
	"./af.js": 456,
	"./ar": 457,
	"./ar-dz": 458,
	"./ar-dz.js": 458,
	"./ar-kw": 459,
	"./ar-kw.js": 459,
	"./ar-ly": 460,
	"./ar-ly.js": 460,
	"./ar-ma": 461,
	"./ar-ma.js": 461,
	"./ar-sa": 462,
	"./ar-sa.js": 462,
	"./ar-tn": 463,
	"./ar-tn.js": 463,
	"./ar.js": 457,
	"./az": 464,
	"./az.js": 464,
	"./be": 465,
	"./be.js": 465,
	"./bg": 466,
	"./bg.js": 466,
	"./bm": 467,
	"./bm.js": 467,
	"./bn": 468,
	"./bn.js": 468,
	"./bo": 469,
	"./bo.js": 469,
	"./br": 470,
	"./br.js": 470,
	"./bs": 471,
	"./bs.js": 471,
	"./ca": 472,
	"./ca.js": 472,
	"./cs": 473,
	"./cs.js": 473,
	"./cv": 474,
	"./cv.js": 474,
	"./cy": 475,
	"./cy.js": 475,
	"./da": 476,
	"./da.js": 476,
	"./de": 477,
	"./de-at": 478,
	"./de-at.js": 478,
	"./de-ch": 479,
	"./de-ch.js": 479,
	"./de.js": 477,
	"./dv": 480,
	"./dv.js": 480,
	"./el": 481,
	"./el.js": 481,
	"./en-SG": 482,
	"./en-SG.js": 482,
	"./en-au": 483,
	"./en-au.js": 483,
	"./en-ca": 484,
	"./en-ca.js": 484,
	"./en-gb": 485,
	"./en-gb.js": 485,
	"./en-ie": 486,
	"./en-ie.js": 486,
	"./en-il": 487,
	"./en-il.js": 487,
	"./en-nz": 488,
	"./en-nz.js": 488,
	"./eo": 489,
	"./eo.js": 489,
	"./es": 490,
	"./es-do": 491,
	"./es-do.js": 491,
	"./es-us": 492,
	"./es-us.js": 492,
	"./es.js": 490,
	"./et": 493,
	"./et.js": 493,
	"./eu": 494,
	"./eu.js": 494,
	"./fa": 495,
	"./fa.js": 495,
	"./fi": 496,
	"./fi.js": 496,
	"./fo": 497,
	"./fo.js": 497,
	"./fr": 498,
	"./fr-ca": 499,
	"./fr-ca.js": 499,
	"./fr-ch": 500,
	"./fr-ch.js": 500,
	"./fr.js": 498,
	"./fy": 501,
	"./fy.js": 501,
	"./ga": 502,
	"./ga.js": 502,
	"./gd": 503,
	"./gd.js": 503,
	"./gl": 504,
	"./gl.js": 504,
	"./gom-latn": 505,
	"./gom-latn.js": 505,
	"./gu": 506,
	"./gu.js": 506,
	"./he": 507,
	"./he.js": 507,
	"./hi": 508,
	"./hi.js": 508,
	"./hr": 509,
	"./hr.js": 509,
	"./hu": 510,
	"./hu.js": 510,
	"./hy-am": 511,
	"./hy-am.js": 511,
	"./id": 512,
	"./id.js": 512,
	"./is": 513,
	"./is.js": 513,
	"./it": 514,
	"./it-ch": 515,
	"./it-ch.js": 515,
	"./it.js": 514,
	"./ja": 516,
	"./ja.js": 516,
	"./jv": 517,
	"./jv.js": 517,
	"./ka": 518,
	"./ka.js": 518,
	"./kk": 519,
	"./kk.js": 519,
	"./km": 520,
	"./km.js": 520,
	"./kn": 521,
	"./kn.js": 521,
	"./ko": 522,
	"./ko.js": 522,
	"./ku": 523,
	"./ku.js": 523,
	"./ky": 524,
	"./ky.js": 524,
	"./lb": 525,
	"./lb.js": 525,
	"./lo": 526,
	"./lo.js": 526,
	"./lt": 527,
	"./lt.js": 527,
	"./lv": 528,
	"./lv.js": 528,
	"./me": 529,
	"./me.js": 529,
	"./mi": 530,
	"./mi.js": 530,
	"./mk": 531,
	"./mk.js": 531,
	"./ml": 532,
	"./ml.js": 532,
	"./mn": 533,
	"./mn.js": 533,
	"./mr": 534,
	"./mr.js": 534,
	"./ms": 535,
	"./ms-my": 536,
	"./ms-my.js": 536,
	"./ms.js": 535,
	"./mt": 537,
	"./mt.js": 537,
	"./my": 538,
	"./my.js": 538,
	"./nb": 539,
	"./nb.js": 539,
	"./ne": 540,
	"./ne.js": 540,
	"./nl": 541,
	"./nl-be": 542,
	"./nl-be.js": 542,
	"./nl.js": 541,
	"./nn": 543,
	"./nn.js": 543,
	"./pa-in": 544,
	"./pa-in.js": 544,
	"./pl": 545,
	"./pl.js": 545,
	"./pt": 546,
	"./pt-br": 547,
	"./pt-br.js": 547,
	"./pt.js": 546,
	"./ro": 548,
	"./ro.js": 548,
	"./ru": 549,
	"./ru.js": 549,
	"./sd": 550,
	"./sd.js": 550,
	"./se": 551,
	"./se.js": 551,
	"./si": 552,
	"./si.js": 552,
	"./sk": 553,
	"./sk.js": 553,
	"./sl": 554,
	"./sl.js": 554,
	"./sq": 555,
	"./sq.js": 555,
	"./sr": 556,
	"./sr-cyrl": 557,
	"./sr-cyrl.js": 557,
	"./sr.js": 556,
	"./ss": 558,
	"./ss.js": 558,
	"./sv": 559,
	"./sv.js": 559,
	"./sw": 560,
	"./sw.js": 560,
	"./ta": 561,
	"./ta.js": 561,
	"./te": 562,
	"./te.js": 562,
	"./tet": 563,
	"./tet.js": 563,
	"./tg": 564,
	"./tg.js": 564,
	"./th": 565,
	"./th.js": 565,
	"./tl-ph": 566,
	"./tl-ph.js": 566,
	"./tlh": 567,
	"./tlh.js": 567,
	"./tr": 568,
	"./tr.js": 568,
	"./tzl": 569,
	"./tzl.js": 569,
	"./tzm": 570,
	"./tzm-latn": 571,
	"./tzm-latn.js": 571,
	"./tzm.js": 570,
	"./ug-cn": 572,
	"./ug-cn.js": 572,
	"./uk": 573,
	"./uk.js": 573,
	"./ur": 574,
	"./ur.js": 574,
	"./uz": 575,
	"./uz-latn": 576,
	"./uz-latn.js": 576,
	"./uz.js": 575,
	"./vi": 577,
	"./vi.js": 577,
	"./x-pseudo": 578,
	"./x-pseudo.js": 578,
	"./yo": 579,
	"./yo.js": 579,
	"./zh-cn": 580,
	"./zh-cn.js": 580,
	"./zh-hk": 581,
	"./zh-hk.js": 581,
	"./zh-tw": 582,
	"./zh-tw.js": 582
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1057;

/***/ }),
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsGrid_vue__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d9aea2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsGrid_vue__ = __webpack_require__(1069);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatisticsGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d9aea2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StatisticsGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__ = __webpack_require__(1065);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatisticsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSource"],
    Detail: __WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    dataSourceLoaded: function dataSourceLoaded(e) {
      this.$emit('ds-loaded', e);
    },
    dataSourceLoadError: function dataSourceLoadError(e) {
      this.$emit('ds-error', e);
    },
    queryFromDetail: function queryFromDetail() {
      console.log('hey, aquery from a detail!');
    },

    detailInit: function detailInit(e) {
      var that = this;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__views_Statistics_Detail_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      });
      instance.$mount();
      instance.$on('filter-detail', function (evt) {
        that.$emit('filter-detail', evt);
      });
      e.detailCell.append(instance.$el);
    },
    setQuery: function setQuery() {
      var _this = this;

      this.axios.post('queries', this.query).then(function (response) {
        _this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        });
      });
    },
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend: function beforeSend(req) {
            console.log(req);
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    refresh: function refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read();
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this2.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  }
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46702f09_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(1068);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46702f09_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows'],
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      fileDownload: {
        url: '',
        title: ''
      },
      url: 'statistics',
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      exporting: false,
      tableInitialized: false,
      tables: [],
      currentTab: ''
    };
  },

  methods: {
    changedTab: function changedTab(a) {
      var _this = this;

      this.currentTab = a;
      this.axios.post('statistics/columns', this.tables[a].query).then(function (response) {
        var data = response.data.data;
        _this.tables[a].columns = data.columns;
        _this.tables[a].aggregateDefinition = data.aggregates;
        _this.tables[a].schemaModelFields = data.fields;
        _this.tables[a].visible = true;
      });
    },
    seQueryFromRow: function seQueryFromRow(e) {
      e.preventDefault();
      var t = e.currentTarget;
      var q = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('query');
      var gridref = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('gridref');
      var field = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('field');
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).closest('tr');
      var dataItem = grid.dataItem(row);
      q.filters = this.addFilter(q.filters, field, dataItem[field]);
      console.log(q);
      this.$emit('filter-detail', {
        item: q
      });
    },
    addFilter: function addFilter(filters, field, value) {
      var found = false;
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes = [{
            id: value,
            name: 'auto'
          }];
          found = true;
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        });
      }
      return filters;
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post('statistics/export', this.tables[this.currentTab].query).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModalDetail.show();
        _this2.exporting = false;
      });
    }
  },
  created: function created() {
    var that = this;

    for (var i = 0; i < this.details.length; i++) {
      var d = this.details[i];
      for (var w = 0; w < d.subrows.length; w++) {
        var subs = d.subrows;

        var q = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));
        var groupby = q.groupby;
        q.groupby = 'none';

        var id = this.rowData[this.query.subrows];

        q.filters = this.addFilter(q.filters, this.query.subrows, id);
        if (groupby !== 'none') {
          var groupById = this.rowData[groupby];
          q.filters = this.addFilter(q.filters, groupby, groupById);
        }

        q.rows = d.rows;
        q.subrows = subs[w];
        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].sub[q.subrows].text,
          details: this.masterRows[q.rows].sub[q.subrows].details,
          field: q.subrows,
          query: q
        });
      }
    }
    console.log('details', this.details);
    console.log('tables', this.tables);
    that.loaded = true;
  }
});

/***/ }),
/* 1067 */,
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.loaded)?_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""},on:{"input":_vm.changedTab}},_vm._l((_vm.tables),function(detail){return _c('b-tab',{key:detail.field,attrs:{"title":detail.title}},[_c('div',{staticClass:"mb-2 text-left"},[(_vm.$auth.check(['all.export', 'dim.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e()]),_vm._v(" "),(detail.visible)?_c('statistics-grid',{ref:'statsGrid' + detail.query.subrows,refInFor:true,attrs:{"gridHeight":"400px","query":detail.query,"name":'detailGrid' + detail,"url":_vm.url,"columns":detail.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":detail.schemaModelFields,"schemaModelId":'id',"aggregateDefinition":detail.aggregateDefinition,"rows":_vm.masterRows,"details":detail.details,"preload":_vm.preload}}):_vm._e(),_vm._v(" "),(!detail.visible)?_c('div',{staticClass:"splash"},[_c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])]):_vm._e()],1)}),1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModalDetail",attrs:{"id":"downloadModalDetail"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v("\n        Close\n      ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-id":_vm.schemaModelId,"schema-model-fields":_vm.schemaModelFields,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"aggregate":_vm.aggregateDefinition,"group":_vm.groupDefinition,"page":_vm.options.dataSource.page},on:{"requestend":_vm.dataSourceLoaded,"error":_vm.dataSourceLoadError}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"scrollable-virtual":true,"data-source-ref":'datasource1',"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"detailinit":_vm.detailInit,"filter-detail":_vm.queryFromDetail}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericGrid_vue__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f1df2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GenericGrid_vue__ = __webpack_require__(1075);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenericGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94f1df2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GenericGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__ = __webpack_require__(1072);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSourceInstaller"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGridInstaller"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountsGrid',
  props: ['name', 'gridHeight', 'schemaModelFields', 'schemaModelId', 'url', 'detailUrl', 'columns', 'preload', 'sortable', 'pageable', 'filterable', 'query', 'details', 'aggregateDefinition', 'rows', 'groupDefinition'],
  components: {
    KendoGrid: __WEBPACK_IMPORTED_MODULE_1__progress_kendo_grid_vue_wrapper__["KendoGrid"],
    KendoDataSource: __WEBPACK_IMPORTED_MODULE_2__progress_kendo_datasource_vue_wrapper__["KendoDataSource"],
    Detail: __WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__["a" /* default */]
  },
  data: function data() {
    return {
      preloadDone: false,
      gridTransport: this.getTransport(),
      schemaTotal: this.getTotal,
      options: {
        dataSource: {
          page: 1,
          sort: null,
          filter: null
        }
      }
    };
  },

  methods: {
    dataSourceLoaded: function dataSourceLoaded(e) {
      this.$emit('ds-loaded', e);
    },
    dataSourceLoadError: function dataSourceLoadError(e) {
      this.$emit('ds-error', e);
    },
    queryFromDetail: function queryFromDetail() {
      console.log('hey, aquery from a detail!');
    },

    detailInit: function detailInit(e) {
      var that = this;
      var ComponentClass = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3__components_Detail_vue__["a" /* default */]);
      var instance = new ComponentClass({
        propsData: {
          url: this.detailUrl,
          query: this.query,
          rowData: e.data,
          details: this.details,
          masterRows: this.rows
        }
      });
      instance.$mount();
      instance.$on('filter-detail', function (evt) {
        that.$emit('filter-detail', evt);
      });
      e.detailCell.append(instance.$el);
    },
    setQuery: function setQuery() {
      var _this = this;

      this.axios.post('queries', this.query).then(function (response) {
        _this.$router.push({
          name: 'statistics.query',
          params: {
            id: response.data.data.uuid
          }
        });
      });
    },
    getTransport: function getTransport() {
      var v = this;
      return {
        read: {
          url: v.axios.defaults.baseURL + this.url,
          type: 'POST',
          data: this.query,
          beforeSend: function beforeSend(req) {
            console.log(req);
            req.setRequestHeader('Authorization', 'Bearer ' + v.$auth.token());
          }
        }
      };
    },
    refresh: function refresh() {
      this.$refs.mygrid.kendoWidget().dataSource.read();
    },
    getTotal: function getTotal(response) {
      return response.meta.pagination.total;
    },
    setColumnsData: function setColumnsData(data, field) {
      for (var i = 0; i < this.columns.length; i++) {
        if (this.columns[i].field === field) {
          this.columns[i].values = data;
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var that = this;
    var apiPreloads = [];
    if (typeof this.preload !== 'undefined' && this.preload != null && this.preload.length > 0) {
      for (var i = 0; i < this.preload.length; i++) {
        apiPreloads.push(this.preload[i].api);
      }
      this.axios.all(apiPreloads.map(function (l) {
        return _this2.axios.get(l);
      })).then(that.axios.spread(function () {
        for (var i = 0; i < that.preload.length; i++) {
          that.setColumnsData(arguments[i].data.data, that.preload[i].field);
        }
        that.preloadDone = true;
      })).catch(function (response) {
        console.error('error loading foreigns', response);
      });
    } else {
      that.preloadDone = true;
    }
  }
});

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cb63f7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(1074);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cb63f7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detail',
  props: ['query', 'rowData', 'details', 'masterRows', 'url'],
  data: function data() {
    return {
      preload: [],
      schemaModelFields: {},
      columns: [],
      aggregateDefinition: [],
      loaded: false,
      tableInitialized: false,
      tables: [],
      exporting: false,
      currentTab: null,
      fileDownload: {
        url: '',
        title: ''
      }
    };
  },

  methods: {
    changedTab: function changedTab(a) {
      var _this = this;

      this.currentTab = a;
      this.axios.post(this.url + '/columns', this.tables[a].query).then(function (response) {
        var data = response.data.data;
        _this.tables[a].columns = data.columns;
        _this.tables[a].aggregateDefinition = data.aggregates;
        _this.tables[a].schemaModelFields = data.fields;
        _this.tables[a].visible = true;
      });
    },
    exportResults: function exportResults(e) {
      var _this2 = this;

      e.preventDefault();
      this.exporting = true;
      this.axios.post(this.url + '/export', this.tables[this.currentTab].query).then(function (response) {
        _this2.fileDownload = response.data;
        _this2.$refs.downloadModalDetail.show();
        _this2.exporting = false;
      });
    },
    seQueryFromRow: function seQueryFromRow(e) {
      e.preventDefault();
      var t = e.currentTarget;
      var q = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('query');
      var gridref = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('gridref');
      var field = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).data('field');
      var grid = this.$refs[gridref][0].$refs.mygrid.kendoWidget();
      var row = __WEBPACK_IMPORTED_MODULE_1__progress_kendo_ui_js_kendo_all_js___default.a.jQuery(t).closest('tr');
      var dataItem = grid.dataItem(row);
      q.filters = this.addFilter(q.filters, field, dataItem[field]);
      console.log(q);
      this.$emit('filter-detail', {
        item: q
      });
    },
    addFilter: function addFilter(filters, field, value) {
      var found = false;
      for (var c = 0; c < filters.length; c++) {
        if (filters[c].field === field) {
          filters[c].includes.push({
            id: value,
            name: 'auto'
          });
          found = true;
        }
      }
      if (!found) {
        filters.push({
          field: field,
          title: '',
          includes: [{
            id: value,
            name: 'auto'
          }],
          excludes: []
        });
      }
      return filters;
    }
  },
  created: function created() {
    var that = this;

    if (this.details) {
      for (var i = 0; i < this.details.length; i++) {
        var d = this.details[i];
        var q = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));
        q.rows = d;
        var id = this.rowData[this.query.rows];
        q.filters = this.addFilter(q.filters, this.query.rows, id);

        this.tables.push({
          visible: false,
          title: this.masterRows[q.rows].text,
          details: this.masterRows[q.rows].details,
          field: q.rows,
          query: q
        });
      }
    }
    console.log('details', this.details);
    console.log('tables', this.tables);
    that.loaded = true;
  }
});

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details"},[(_vm.loaded)?_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"small":"","card":""},on:{"input":_vm.changedTab}},_vm._l((_vm.tables),function(detail){return _c('b-tab',{key:detail.field,attrs:{"title":detail.title}},[_c('div',{staticClass:"mb-2 text-left"},[(_vm.$auth.check(['all.export']))?_c('a',{attrs:{"href":"#"},on:{"click":_vm.exportResults}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" exportar")]):_vm._e()]),_vm._v(" "),(detail.visible)?_c('generic-grid',{ref:'statsGrid' + detail.query.subrows,refInFor:true,attrs:{"gridHeight":"400px","query":detail.query,"name":'detailGrid' + detail,"url":_vm.url,"columns":detail.columns,"pageable":true,"filterable":true,"sortable":true,"schemaModelFields":detail.schemaModelFields,"schemaModelId":'id',"aggregateDefinition":detail.aggregateDefinition,"rows":_vm.masterRows,"details":detail.details,"preload":_vm.preload,"detail-url":_vm.url}}):_vm._e(),_vm._v(" "),(!detail.visible)?_c('div',{staticClass:"splash"},[_c('div',{staticClass:"container  d-flex h-100"},[_c('div',{staticClass:"row justify-content-center text-primary w-100 align-self-center text-white"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])])]):_vm._e()],1)}),1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"downloadModalDetail",attrs:{"id":"downloadModalDetail"}},[_vm._v("\n    O ficheiro está pronto:\n    "),_c('a',{attrs:{"href":_vm.fileDownload.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.fileDownload.title))]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloadDone)?_c('div',[_c('kendo-datasource',{ref:"datasource1",attrs:{"transport":_vm.gridTransport,"schema-model-id":_vm.schemaModelId,"schema-model-fields":_vm.schemaModelFields,"schema-data":'data',"server-paging":false,"server-filtering":false,"server-sorting":false,"aggregate":_vm.aggregateDefinition,"group":_vm.groupDefinition,"page":_vm.options.dataSource.page},on:{"requestend":_vm.dataSourceLoaded,"error":_vm.dataSourceLoadError}}),_vm._v(" "),_c('kendo-grid',{ref:"mygrid",attrs:{"scrollable-virtual":true,"data-source-ref":'datasource1',"filterable":_vm.filterable,"sortable":_vm.sortable,"columns":_vm.columns,"scrollable":true},on:{"detailinit":_vm.detailInit,"filter-detail":_vm.queryFromDetail}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */,
/* 1077 */,
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, exports) {

module.exports = {

  request: function request(req, token) {
    this.options.http._setHeaders.call(this, req, {
      Authorization: 'Bearer ' + token
    });
  },

  response: function response(res) {
    var headers = this.options.http._getHeaders.call(this, res);
    var token = headers.Authorization || headers.authorization;
    if (!token && typeof res.data.token !== 'undefined') {
      token = res.data.token;
      return token;
    }
    if (!token && typeof res.data.access_token !== 'undefined') {
      token = res.data.access_token;
      return token;
    }

    if (token) {
      token = token.split(/Bearer:?\s?/i);
      return token[token.length > 1 ? 1 : 0].trim();
    }
  }
};

/***/ })
],[584]);


// WEBPACK FOOTER //
// static/js/app.4cf1811b092e7ab455de.js